import AddReport from "../components/addReport";
import React, { useEffect, useState, useRef } from "react";
import * as swInspectionAction from "../../../../redux/storm-water/actions/swInspectionAction";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../../../library/common/Loader";
import * as swCommonAction from "../../../../redux/storm-water/actions/swCommonAction";
import * as projectAction from "../../../../redux/storm-water/actions/projectAction";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import { getQestSetDetail } from "../../../../services/storm-water/swInspectionService";

import {
  API_STATUS,
  HBNEXT_ORG_ID,
  INSPECTION_STATUS,
  LOGIN_ORG_ID,
  ORG_ID,
  ORG_NAME,
  SIGNOFF_METHOD_TYPE,
  USER_ID,
} from "../../../../constant/constant";
import {
  DATE_VALIDATE,
  INSSTATUS,
} from "../../../../constant/storm-water/constant";
import {
  formatRainfall,
  getFormatedDate,
  InactiveClient,
  parseDate,
  validateFileSize,
} from "../../../../utils/helper";
import SuccessScreen from "../../../../library/custom/success/successScreen";
import {
  ACCESS_DENIED,
  SW_INSPECTION_LIST,
  SWDASHBOARD,
} from "../../../../constant/routeContant";
import { useLocation } from "react-router-dom";
import PreviousOpenItems from "../components/addReport/previousOpenItems";
import * as assetsAction from "../../../../redux/actions/assetsAction";
import * as clientAction from "../../../../redux/actions/clientAction";
import { useNavigate } from "react-router-dom";
import { fileUpload } from "../../../../services/fileUploadService";
import { checkPrivileges } from "../../../../utils/rolesHelper";
import * as swprojectAction from "../../../../redux/storm-water/actions/projectAction";
import {
  generateInspectionGroundStabilization,
  generateSwInspectionLotDisturbance,
  generateSwInspectionNewOrRevisedMeasures,
  generateSwInspectionObservation,
  getQuestionIdsFromCategories,
  listInspectionCategoryObject,
  processCategories,
  processProjectPhaseData,
  processRainfallData,
  transformCategoryData,
  transformProjectStatus,
  transformSampleTaken,
  updateCategoryPercent,
  updateQuestion,
  updateSubCategoryPercent,
  validateInspectionCategories,
  processSiteComplianceData,
  filterGroundStabilizationRows,
  filterObservationRows,
  filterNewOrRevisedMeasuresRows,
  filterLotDisturbanceRows,
  isRainfallEmpty,
} from "../../../../utils/swInspectionHelper";
import { getReferenceData } from "../../../../redux/actions/incpectionAction";
import { getUserInfo as helperGetUserInfo } from "../../../../utils/helper";
import { useDebounce } from "../../../../utils/useDebounceSearch";
import BackBtn from "../../../../library/custom/backBtn/backBtn";

const AddReportContainer = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const reportDetail = location?.state?.row;
  const editMode = location?.state?.editMode;
  const addMode = location?.state?.addMode;
  const addDirectInspection = location?.state?.addDirectInspection ?? false;
  const [constructionActivityId, setConstructionActivityId] = useState(null);
  const [isConstructionActivityId, setIsConstructionActivityId] =
    useState(null);
  const [questionSetId, setQuestionSetId] = useState(null);
  const [questionSetUpId, setQuestionSetUpId] = useState(null);
  const [inspectionTypeId, setInspectionTypeId] = useState();
  const [stateValue, setStateValue] = useState();
  const [inspectionId, setInspectionId] = useState();
  const hiddenAttendeeSignatureInput = useRef([]);
  const [imageCheck, setImageCheck] = useState(false);
  const [isNotAddMedia, setIsNotAddMedia] = useState(false);
  const [listPermitte, setListPermitte] = useState();
  const [isFluid, setIsFluid] = useState(false);
  const [frequencyInDays, setFrequencyInDays] = useState(null);
  const [dateRangeError, setDateRangeError] = useState(false);
  const [errorFrequencyInDays, setErrorFrequencyInDays] = useState(false);
  const [fileUploadData, setFileUploadData] = useState();
  const [isLoader, setIsLoader] = useState(false);
  const [fileError, setFileError] = useState(null);
  const [uniqeFileError, setUniqeFileError] = useState(false);
  const [isNorthCarolina, setIsNorthCarolina] = useState(false);
  const [isClientInactive, setIsClientInactive] = useState(false);
  const [swInspectionConfQuestionAns, setSwInspectionConfQuestionAns] =
    useState([]);
  const [swInspectionRainfallData, setSwInspectionRainfallData] = useState([]);
  const [swInspectionCurrentProjectPhase, setSwInspectionCurrentProjectPhase] =
    useState([]);
  const [swInspectionGroundStabilization, setSwInspectionGroundStabilization] =
    useState(generateInspectionGroundStabilization(5));
  const [swInspectionObservation, setSwInspectionObservation] = useState(
    generateSwInspectionObservation(5),
  );
  const [swInspectionLotDisturbance, setSwInspectionLotDisturbance] = useState(
    generateSwInspectionLotDisturbance(5),
  );
  const [
    swInspectionNewOrRevisedMeasures,
    setSwInspectionNewOrRevisedMeasures,
  ] = useState(generateSwInspectionNewOrRevisedMeasures(5));
  const [swInspectionSiteCompliance, setSwInspectionSiteCompliance] = useState(
    [],
  );

  const [frequencyValueError, setFrequencyValueError] = useState(false);
  const [signoffMethodValue, setSignoffMethodValue] = useState();
  const [certifyStatementIdValue, setCertifyStatementIdValue] = useState();
  const [acknowledgement, setAcknowledgement] = useState("");
  const swRainFallData = useSelector((state) => state?.swrainFallData);
  const [checkedAcknowledgement, setCheckedAcknowledgement] =
    useState(editMode);
  const [checkedAcknowledgementError, setCheckedAcknowledgementError] =
    useState(false);
  const [projectSearchText, setProjectSearchText] = useState();
  const [searchClientText, setSearchClientText] = useState();
  const debouncedSearch = useDebounce(projectSearchText, 500);
  const debouncedClientSearch = useDebounce(searchClientText, 500);
  const [epscFunctioning, setEpscFunctioning] = useState(3);
  const [epscInstalled, setEpscInstalled] = useState(3);

  const swGetRainFallDataList = (data) => {
    dispatch(swprojectAction.swGetRainfallDataList(data));
  };
  const dateRangeHandler = (value) => {
    const newValue = parseInt(value, 10);
    if (
      newValue === null ||
      (!isNaN(newValue) && newValue >= 1 && newValue <= 365)
    ) {
      setFrequencyInDays(newValue);
      setDateRangeError(false);
    } else {
      setFrequencyInDays(null);
      setDateRangeError(true);
    }
  };
  const getSwQuestionSetDetail = useSelector(
    (state) => state.getSwQuestionSetDetail,
  );

  const [userInfo, setUserInfo] = useState(() => helperGetUserInfo());

  useEffect(() => {
    const stored = helperGetUserInfo();
    if (JSON.stringify(stored) !== JSON.stringify(userInfo)) {
      setUserInfo(stored);
    }
    const onStorage = (e) => {
      if (e.key === "userInfo") {
        try {
          setUserInfo(e.newValue ? JSON.parse(e.newValue) : null);
        } catch (err) {
          setUserInfo(null);
        }
      }
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  const navigate = useNavigate();

  const date = new Date();
  const isSignatureProfile = userInfo?.signatureUrl;
  const [notAcceptable, setAcceptable] = useState("");
  const [routeSatus, setRouteSatus] = useState();
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
  const formattedTime = `${hours}:${formattedMinutes}`;
  const mapId = reportDetail?.setupId;
  const [projects, setProjects] = useState();
  const [clients, setClients] = useState();
  const [firstClientError, setFirstClientError] = useState(false);
  const [frequencyValue, setFrequencyValue] = useState();
  const [isMediaAllowed, setIsMediaAllowed] = useState(false);
  const [isGeorgiaState, setIsGeorgiaState] = useState(false);
  const [projectStatus, setProjectStatus] = useState();
  const [previousItem, setPreviousItem] = useState([]);
  const [closedLocationIds, setClosedLocationIds] = useState([]);
  const [listInspectionCategory, setListInspectionCategory] = useState([]);
  const [alsoSubmitRoutineInspection, setAlsoSubmitRoutineInspection] =
    useState(false);
  const [isDirectIns, setIsDirectIns] = useState(null);
  const [isTennessee, setIsTennessee] = useState(false);
  const [isSouthCarolina, setIsSouthCarolina] = useState(false);
  const handleChangeDefault = () => {
    setFrequencyValue();
    setAlsoSubmitRoutineInspection(!alsoSubmitRoutineInspection);
  };

  function handleAllProjectSearch(event, value) {
    if (clients?.key) {
      setFirstClientError(false);
      setProjectSearchText(event.target.value);
    } else {
      setFirstClientError(true);
    }
  }

  useEffect(() => {
    if (parseInt(LOGIN_ORG_ID()) !== parseInt(HBNEXT_ORG_ID)) {
      setClients({
        key: ORG_ID(),
        value: ORG_NAME(),
      });
      // setFormValue({ ...formValue, customerName: userInfo?.clientName });
    }
  }, [LOGIN_ORG_ID(), ORG_NAME(), ORG_ID()]);

  useEffect(() => {
    if (ORG_ID() != LOGIN_ORG_ID()) {
      setClients({
        key: ORG_ID(),
        value: ORG_NAME(),
      });
    }
  }, []);

  const allProject = useSelector((state) => state.getAssetDynomoList);
  const isProjectLoading = allProject?.isLoading;

  const allClients = useSelector((state) => state.searchAllClientsReducerData);
  const isSearchClientLoading = allClients.isLoading;

  const searchClient = (event) => {
    setSearchClientText(event.target.value);
  };

  const getSwProjectDetailData = useSelector(
    (state) => state.getSwProjectDetail,
  );

  const getProjectDetails = (data) => {
    dispatch(projectAction.getProjectDetails(data));
  };

  const inspectionQuestionSetList = useSelector(
    (state) => state.getQuestionSetOnProject,
  );

  const isQuestionSetLoading = useSelector(
    (state) => state.swQuestionSetList?.isLoading,
  );

  const getInspectionQuestionSetListData = (data) => {
    dispatch(swInspectionAction.getQuestionSetOnProject(data));
  };

  const inspectionHeaderDetails = useSelector(
    (state) => state.getInspectionHeaderDetails,
  );
  const getInspectionHeaderDetailsData = (data) => {
    dispatch(swInspectionAction.getInspectionHeaderDetails(data));
  };

  let Flags;
  if (isNorthCarolina || isSouthCarolina) {
    Flags = [6, 3, 4, 8, 9, 5, 11, 12, 13];
  } else if (isTennessee) {
    Flags = [6, 3, 4, 8, 9, 5, 14, 13];
  } else {
    Flags = [6, 3, 4, 8, 9, 5, 13];
  }
  const refData = {
    flags: Flags,
    orgId: clients?.key,
  };
  const { weather } = useSelector((state) => state.inspection);
  const getSwReference = useSelector((state) => state.getSwReference);
  const getSwReferenceData = (data) => {
    dispatch(swCommonAction.getSwReference(data));
  };
  useEffect(() => {
    getSwReferenceData(refData);
  }, [clients, isNorthCarolina, isTennessee, isSouthCarolina]);

  useEffect(() => {
    dispatch(swInspectionAction.clearSwInspectionDelete(""));
    const data = {
      isAll: false,
    };
    dispatch(getReferenceData(data));
  }, []);

  const getSwQuestionSetDetailData = (data) => {
    dispatch(swInspectionAction.getSwQuestionSetDetail(data));
  };

  const getSwInspectionDetail = useSelector(
    (state) => state.getSwInspectionDetail,
  );
  const getSwInspectionDetailData = (data) => {
    dispatch(swInspectionAction.getSwInspectionDetail(data));
  };

  const getInTyFeByInTyList = useSelector((state) => state.getInTyFeByInTyList);
  const getInTyFeByInTyListData = (data) => {
    dispatch(swInspectionAction.getInTyFeByInTyList(data));
  };
  const createSwInspection = useSelector((state) => state.createSwInspection);
  const updateSwInspection = useSelector((state) => state.updateSwInspection);
  const swOpenItemDetail = useSelector((state) => state.swOpenItemDetail);
  const getOpenItemDetailData = (data) => {
    dispatch(swInspectionAction.createSwOpenItemDetail(data));
  };
  const createSwInspectionCloseItem = useSelector(
    (state) => state.createSwInspectionCloseItem,
  );
  const createSwInspectionCloseItemData = (data) => {
    dispatch(swInspectionAction.createSwInspectionCloseItem(data));
  };

  const createSwInspectionItemComment = useSelector(
    (state) => state.createSwInspectionItemComment,
  );
  const createSwInspectionItemCommentData = (data) => {
    dispatch(swInspectionAction.createSwInspectionItemComment(data));
  };

  const intialState = {
    questionSetName: "",
    projectName: "",
    projectId: "",
    customerName: "",
    projectNo: "",
    primaryInspector: "",
    dateofInspection: date,
    timeofInspection: formattedTime,
    WeatherAtTimeofInspection: "",
    soilTypeId: "",
    rainfall: "",
    constructionStageId: 0,
    sampleTaken: null,
    primaryPermitteeName: "",
    disturbedAcreage: "",
    permitteOrNPDESNumber: "",
    primaryPermitteName: "",
    generalComments: "",
    isRainfallChecked: null,
    siteAssessment: null,
    tnpeNumber: "",
    cpescNumber: "",
    jobTitle: "",
    certificationNumber: "",
    email: "",
    companyPerformingInspection: "",
    phoneNumber: "",
    clientAddress1: "",
    clientAddress2: "",
    clientCity: "",
    clientState: "",
    clientZipCode: "",
  };
  const [formValue, setFormValue] = useState(intialState);

  useEffect(() => {
    if (!userInfo) return;

    setFormValue((prev) => ({
      ...prev,
      primaryInspector: `${userInfo.firstName ?? ""} ${
        userInfo.lastName ?? ""
      }`.trim(),
      email: userInfo.email ?? prev.email,
      companyPerformingInspection:
        userInfo.organization ?? prev.companyPerformingInspection,
      phoneNumber: userInfo.phoneNumber ?? prev.phoneNumber,
      jobTitle: userInfo.jobTitle ?? prev.jobTitle ?? "N/A",
      certificationNumber:
        userInfo.certificationNumber ?? prev.certificationNumber ?? "N/A",
      clientAddress1: userInfo.clientAddress1 ?? prev.clientAddress1,
      clientAddress2: userInfo.clientAddress2 ?? prev.clientAddress2,
      clientCity: userInfo.clientCity ?? prev.clientCity,
      clientState: userInfo.clientState ?? prev.clientState,
      clientZipCode: userInfo.clientZipCode ?? prev.clientZipCode,
    }));
  }, [userInfo]);

  const showLoader = useSelector(
    (state) =>
      state.getSwQuestionSetProjectMapList?.isLoading ||
      state.getSwQuestionSetDetail?.isLoading ||
      state.getInTyFeByInTyList?.isLoading ||
      state.createSwInspection.isLoading ||
      state.getSwInspectionDetail?.isLoading ||
      state.fileUpload?.isLoading ||
      state.updateSwInspection.isLoading ||
      state.swOpenItemDetail.isLoading ||
      state.createSwInspectionCloseItem.isLoading ||
      state.createSwInspectionItemComment.isLoading ||
      state.getSwReference.isLoading ||
      state.swQuestionSetList?.isLoading ||
      state.getSwProjectDetail?.isLoading ||
      state.getInspectionHeaderDetails?.isLoading ||
      state?.swrainFallData?.isLoading,
  );

  const statusApi = useSelector(
    (state) =>
      state.getSwQuestionSetDetail?.isError ||
      state.getSwInspectionDetail?.isError,
  );

  const handleFrequencyChange = (e) => {
    setFrequencyValue(e.target.value);
  };
  const onChangeProjects = (value) => {
    setInspectionTypeId();
    setFrequencyValue();
    setQuestionSetId();
    setPreviousItem([]);
    setListInspectionCategory([]);
    setQuestionSetUpId(null);
    setConstructionActivityId(null);
    setProjectStatus(null);
    setFormValue({
      ...formValue,
      projectId: value?.key,
      questionSetName: "",
      projectName: "",
      customerName: "",
      projectNo: "",
      primaryInspector: "",
      dateofInspection: date,
      timeofInspection: formattedTime,
      WeatherAtTimeofInspection: "",
      soilTypeId: "",
      rainfall: "",
      constructionStageId: 0,
      sampleTaken: null,
      primaryPermitteeName: "",
      disturbedAcreage: "",
      permitteOrNPDESNumber: "",
      primaryPermitteName: "",
      generalComments: "",
      isRainfallChecked: null,
      siteAssessment: null,
      tnpeNumber: "",
      cpescNumber: "",
      jobTitle: "",
      certificationNumber: "",
      email: "",
      companyPerformingInspection: "",
      phoneNumber: "",
      clientAddress1: "",
      clientAddress2: "",
      clientCity: "",
      clientState: "",
      clientZipCode: "",
    });
    setProjects(value);
    if (value?.key) {
      const data = {
        projectId: value?.key,
        orgId: clients?.key,
      };
      getInspectionQuestionSetListData(data);
    }
    setSwInspectionConfQuestionAns([]);
    setSwInspectionRainfallData([]);
    setSwInspectionCurrentProjectPhase([]);
    setSwInspectionGroundStabilization([]);
    setSwInspectionObservation([]);
    setSwInspectionLotDisturbance([]);
    setSwInspectionNewOrRevisedMeasures([]);
    setSignatureError(false);
    setDateRangeError(false);
    setFrequencyValueError(false);
    setTwoQuestionError(false);
    setProjectPhaseError(false);
    setSiteComplianceError(false);
    setIsProjectName(false);
    setIsProjectNo(false);
    setIsTimeofInspection(false);
    setIsWeatherAtTimeofInspection(false);
    setIsRainFallError(false);
    setIsSampleTaken(false);
    setIsReportId(false);
    setIsCustomerName(false);
    setIsDateofInspection(false);
    setIsInspectionTypeId(false);
    setIsPrimaryInspector(false);
    setIsStageOfConstruction(false);
    setIsCurrentApproximateDisturbedAcreage(false);
    setIsSoilTypeId(false);
    setIsConstructionActivityId(false);
    setIsProjectStatus(false);
    setSwInspectionSiteCompliance([]);
  };

  const onChangeClients = (value) => {
    setInspectionTypeId();
    setFrequencyValue();
    setQuestionSetId();
    setPreviousItem([]);
    setListInspectionCategory([]);
    setQuestionSetUpId(null);
    setConstructionActivityId(null);
    setProjectStatus(null);
    setProjects();
    setFormValue({
      ...formValue,
      projectId: "",
      questionSetName: "",
      projectName: "",
      customerName: "",
      projectNo: "",
      primaryInspector: "",
      dateofInspection: date,
      timeofInspection: formattedTime,
      WeatherAtTimeofInspection: "",
      soilTypeId: "",
      rainfall: "",
      constructionStageId: 0,
      sampleTaken: null,
      primaryPermitteeName: "",
      disturbedAcreage: "",
      permitteOrNPDESNumber: "",
      primaryPermitteName: "",
      generalComments: "",
      isRainfallChecked: null,
      siteAssessment: null,
      tnpeNumber: "",
      cpescNumber: "",
      jobTitle: "",
      certificationNumber: "",
      email: "",
      companyPerformingInspection: "",
      phoneNumber: "",
      clientAddress1: "",
      clientAddress2: "",
      clientCity: "",
      clientState: "",
      clientZipCode: "",
    });
    setClients(value);
    setSwInspectionConfQuestionAns([]);
    setSwInspectionRainfallData([]);
    setSwInspectionCurrentProjectPhase([]);
    setSwInspectionGroundStabilization([]);
    setSwInspectionObservation([]);
    setSwInspectionLotDisturbance([]);
    setSwInspectionNewOrRevisedMeasures([]);
    setSignatureError(false);
    setDateRangeError(false);
    setFrequencyValueError(false);
    setTwoQuestionError(false);
    setProjectPhaseError(false);
    setSiteComplianceError(false);
    setIsProjectName(false);
    setIsProjectNo(false);
    setIsTimeofInspection(false);
    setIsWeatherAtTimeofInspection(false);
    setIsRainFallError(false);
    setIsSampleTaken(false);
    setIsReportId(false);
    setIsCustomerName(false);
    setIsDateofInspection(false);
    setIsInspectionTypeId(false);
    setIsPrimaryInspector(false);
    setIsStageOfConstruction(false);
    setIsCurrentApproximateDisturbedAcreage(false);
    setIsSoilTypeId(false);
    setIsConstructionActivityId(false);
    setIsProjectStatus(false);
    setSwInspectionSiteCompliance([]);
  };

  const handleConstructionActivitySetChange = (event) => {
    setConstructionActivityId(event?.target?.value);
  };

  const handleInspectionTypeSetChange = (event) => {
    setInspectionTypeId(event?.target?.value);
    setFrequencyValue();
    setSwInspectionConfQuestionAns([]);
    setSwInspectionGroundStabilization(
      generateInspectionGroundStabilization(5),
    );
    setSwInspectionObservation(generateSwInspectionObservation(5));
    setSwInspectionLotDisturbance(generateSwInspectionLotDisturbance(5));
    setSwInspectionNewOrRevisedMeasures(
      generateSwInspectionNewOrRevisedMeasures(5),
    );
    setSignatureError(false);
    setDateRangeError(false);
    setFrequencyValueError(false);
    setTwoQuestionError(false);
    setProjectPhaseError(false);
    setSiteComplianceError(false);
    setIsProjectName(false);
    setIsProjectNo(false);
    setIsTimeofInspection(false);
    setIsWeatherAtTimeofInspection(false);
    setIsRainFallError(false);
    setIsSampleTaken(false);
    setIsReportId(false);
    setIsCustomerName(false);
    setIsDateofInspection(false);
    setIsInspectionTypeId(false);
    setIsPrimaryInspector(false);
    setIsStageOfConstruction(false);
    setIsCurrentApproximateDisturbedAcreage(false);
    setIsSoilTypeId(false);
    setIsConstructionActivityId(false);
    setIsProjectStatus(false);
  };

  const handleQuestionSetChange = async (event) => {
    setQuestionSetId(event.target.value);
    const data = {
      questionSetId: event.target.value,
      projectId: projects?.key,
      orgId: clients?.key,
    };
    getSwInspectionDetailData(data);

    setCertifyStatementIdValue("");
    setAcknowledgement("");
    setCheckedAcknowledgement(editMode);

    const categoryData = await getQestSetDetail(data);
    if (categoryData?.data?.questionSetCertifyStatementId) {
      setCertifyStatementIdValue(
        categoryData?.data?.questionSetCertifyStatementId,
      );
      setSignoffMethodValue(categoryData?.data?.questionSetSignOffMethodType);
    }

    setIsRainFallError(false);
    setSwInspectionConfQuestionAns([]);
    setSwInspectionGroundStabilization(
      generateInspectionGroundStabilization(5),
    );
    setSwInspectionObservation(generateSwInspectionObservation(5));
    setSwInspectionLotDisturbance(generateSwInspectionLotDisturbance(5));
    setSwInspectionNewOrRevisedMeasures(
      generateSwInspectionNewOrRevisedMeasures(5),
    );
    setSignatureError(false);
    setDateRangeError(false);
    setFrequencyValueError(false);
    setTwoQuestionError(false);
    setProjectPhaseError(false);
    setSiteComplianceError(false);
    setIsProjectName(false);
    setIsProjectNo(false);
    setIsTimeofInspection(false);
    setIsWeatherAtTimeofInspection(false);
    setIsRainFallError(false);
    setIsSampleTaken(false);
    setIsReportId(false);
    setIsCustomerName(false);
    setIsDateofInspection(false);
    setIsInspectionTypeId(false);
    setIsPrimaryInspector(false);
    setIsStageOfConstruction(false);
    setIsCurrentApproximateDisturbedAcreage(false);
    setIsSoilTypeId(false);
    setIsConstructionActivityId(false);
    setIsProjectStatus(false);
  };

  useEffect(() => {
    if (addDirectInspection || !editMode) {
      setInspectionId();
      setInspectionTypeId();
      setQuestionSetId();
      setQuestionSetUpId();
      setFrequencyValue();
      setStateValue();
      setProjects();
      setPreviousItem([]);
      setListInspectionCategory([]);
      setConstructionActivityId(null);
      setProjectStatus(null);
      setFormValue({
        ...formValue,
        projectId: "",
        questionSetName: "",
        projectName: "",
        customerName: "",
        projectNo: "",
        primaryInspector: "",
        dateofInspection: date,
        timeofInspection: formattedTime,
        WeatherAtTimeofInspection: "",
        soilTypeId: "",
        rainfall: "",
        constructionStageId: 0,
        sampleTaken: null,
        primaryPermitteeName: "",
        disturbedAcreage: "",
        permitteOrNPDESNumber: "",
        primaryPermitteName: "",
        generalComments: "",
        isRainfallChecked: null,
        siteAssessment: null,
        tnpeNumber: "",
        cpescNumber: "",
        jobTitle: "",
        certificationNumber: "",
        email: "",
        companyPerformingInspection: "",
        phoneNumber: "",
        clientAddress1: "",
        clientAddress2: "",
        clientCity: "",
        clientState: "",
        clientZipCode: "",
      });
    }
  }, [addDirectInspection, editMode]);

  const openItemObject = (data) => {
    return data.map((item) => {
      return {
        id: Date.now() + Math.floor(Math.random() * 100),
        isComment: false,
        isCloseItem: false,
        commentText: "",
        actionTakenText: "",
        dateClosedText: date,
        dateClosedError: false,
        actionTakenError: false,
        commentTextError: false,
        locationId: item?.locationId,
        questionId: item?.questionId,
        location: item?.location,
        itemDetail: item?.itemDetail,
        item: item?.item,
        inspectionId: item?.inspectionId,
        files: item?.files,
        dateRecorded: item?.dateRecorded,
        dateClosed: item?.dateClosed,
        comment: item?.comment,
        actionTaken: item?.actionTaken,
        closedId: "",
        closedIdValue: "",
        isClosedIdError: false,
        status: item?.status,
        question: item?.question,
      };
    });
  };
  useEffect(() => {
    if (getSwInspectionDetail?.status === API_STATUS.SUCCESS) {
      if (
        (createSwInspectionItemComment.status === API_STATUS.SUCCESS ||
          createSwInspectionCloseItem.status === API_STATUS.SUCCESS) &&
        !getSwInspectionDetail?.data?.setupId &&
        projects &&
        questionSetId
      ) {
        const getQuestionIds =
          getSwQuestionSetDetail?.data?.questionSetCatDetails
            ?.map((x) =>
              x?.subcategories?.flatMap((y) =>
                y?.questions?.filter((z) => z.isSelected).map((xz) => xz.key),
              ),
            )
            .flat()
            .filter((id) => id !== undefined);

        const data = {
          questionList: getQuestionIds,
          setupId: null,
          projectId: projects?.key,
          questionSetId: questionSetId,
          itemStatus: 2,
          orgId: clients?.key,
        };
        getOpenItemDetailData(data);
      }

      if (
        (createSwInspectionItemComment.status === API_STATUS.SUCCESS ||
          createSwInspectionCloseItem.status === API_STATUS.SUCCESS) &&
        getSwInspectionDetail?.data?.setupId
      ) {
        const getQuestionIds = getSwInspectionDetail?.data?.categoriesView
          ?.map((x) =>
            x?.subcategoriesView?.flatMap((y) =>
              y?.insQuesAnsReportView?.map((z) => z.questionId),
            ),
          )
          .flat()
          .filter((id) => id !== undefined);

        const data = {
          questionList: getQuestionIds,
          setupId: null,
          projectId: getSwInspectionDetail?.data?.projectId,
          questionSetId: getSwInspectionDetail?.data?.questionSetId,
          itemStatus: 2,
          orgId: clients?.key,
        };
        getOpenItemDetailData(data);
      }
    }
  }, [
    getSwInspectionDetail,
    createSwInspectionItemComment,
    createSwInspectionCloseItem,
    projects,
    questionSetId,
    clients,
  ]);

  useEffect(() => {
    if (swOpenItemDetail.status === API_STATUS.SUCCESS) { 
      const openItemList = swOpenItemDetail.data.openItemList ?? [];
      const appendixItems = (
        getSwInspectionDetail?.data?.appendixOpenItems ?? []
      )
        .filter(
          (appendixItem) =>
            !openItemList.some(
              (openItem) => openItem.locationId === appendixItem.locationId,
            ),
        )
        .map((appendixItem) =>
          closedLocationIds.includes(appendixItem.locationId)
            ? { ...appendixItem, status: INSPECTION_STATUS.Closed }
            : appendixItem,
        );
      setPreviousItem(openItemObject([...openItemList, ...appendixItems]));
    }
  }, [swOpenItemDetail, getSwInspectionDetail, closedLocationIds]);

  const [isContractorProfileSignature, setIsContractorProfileSignature] =
    useState(false);
  const [selectedContractorSignature, setSelectedContractorSignature] =
    useState("");
  const [signaureFileError, setSignaureFileError] = useState(false);
  const [signaureFileErrorMessage, setSignaureFileErrorMessage] = useState("");

  const uploadContractorSignatureFile = (data) => {
    const validation = validateFileSize(data);
    if (!validation.isValid) {
      setSignaureFileErrorMessage(validation.errorMessage);
      setSignaureFileError(true);
      return;
    }
    setIsContractorProfileSignature(true);
    setIsLoader(true);
    fileUpload(data)
      .then((res) => {
        setIsLoader(false);
        const files = { files: res };
        setFileUploadData(files);
        setSignaureFileError(false);
      })
      .catch((error) => {
        setSignaureFileErrorMessage("Error while uploading files.");
        setSignaureFileError(true);
      });
  };

  const contractorsignatureUpload = (event) => {
    const fileUploaded = event.target.files[0];
    handleContractorSignatureUploadMethod(fileUploaded);
  };
  const handleContractorSignatureUploadMethod = (data) => {
    uploadContractorSignatureFile(data);
  };
  useEffect(() => {
    if (isContractorProfileSignature) {
      if (fileUploadData && imageCheck) {
        setSelectedContractorSignature(fileUploadData?.files[0]?.fileUrl);
      }
    }
  }, [fileUploadData, imageCheck]);
  useEffect(() => {
    if (isSignatureProfile) {
      setSelectedContractorSignature(isSignatureProfile);
    }
  }, [isSignatureProfile]);

  useEffect(() => {
    if (getSwQuestionSetDetail.status === API_STATUS.SUCCESS) {
      setListInspectionCategory(
        listInspectionCategoryObject(getSwQuestionSetDetail.data),
      );
      if (getSwQuestionSetDetail?.data?.certifyStatementId && editMode) {
        setCertifyStatementIdValue(
          getSwQuestionSetDetail?.data?.certifyStatementId,
        );
        setAcknowledgement(getSwQuestionSetDetail?.data?.certifyStatement);
        setSignoffMethodValue(getSwQuestionSetDetail?.data?.signOffMethodType);
      }
      setPreviousItem([]);
      setSwInspectionGroundStabilization(
        generateInspectionGroundStabilization(5),
      );
      setSwInspectionObservation(generateSwInspectionObservation(5));
      setSwInspectionLotDisturbance(generateSwInspectionLotDisturbance(5));
      setSwInspectionNewOrRevisedMeasures(
        generateSwInspectionNewOrRevisedMeasures(5),
      );
    }
  }, [getSwQuestionSetDetail]);

  useEffect(() => {
    if (getSwInspectionDetail?.status === API_STATUS.SUCCESS) {
      if (
        !editMode &&
        questionSetId &&
        addMode &&
        !getSwInspectionDetail?.data?.setupId
      ) {
        const data = {
          questionSetId: questionSetId,
          orgId: clients?.key,
        };
        getSwQuestionSetDetailData(data);
      }
      if (questionSetId && !mapId && !getSwInspectionDetail?.data?.setupId) {
        const data = {
          questionSetId: questionSetId,
          orgId: clients?.key,
        };
        getSwQuestionSetDetailData(data);
      }
    }
  }, [
    reportDetail,
    questionSetId,
    editMode,
    addMode,
    getSwInspectionDetail,
    clients,
  ]);

  useEffect(() => {
    if (
      inspectionTypeId &&
      getSwInspectionDetail?.status === API_STATUS.SUCCESS
    ) {
      const data = {
        orgId: clients?.key ? clients?.key : ORG_ID(),
        inspectionTypeId: inspectionTypeId ? inspectionTypeId : "",
        stateId: stateValue ? stateValue : "",
        projectId: projects?.key ? projects?.key : "",
      };
      getInTyFeByInTyListData(data);
    }
  }, [inspectionTypeId, stateValue, projects, getSwInspectionDetail, clients]);

  useEffect(() => {
    if ((projects || mapId) && clients && inspectionTypeId) {
      const headerDetail = {
        orgId: clients?.key ? clients?.key : ORG_ID(),
        setupId: mapId ? mapId : "",
        projectId: projects?.key ? projects?.key : "",
        inspectionType: inspectionTypeId ? inspectionTypeId : "",
      };
      getInspectionHeaderDetailsData(headerDetail);
    }
  }, [projects, getSwInspectionDetail, clients, inspectionTypeId]);

  const openItemHandler = (questionId, locationId, targetName, event) => {
    const openItemClone = [...previousItem];
    openItemClone.forEach((openItem) => {
      if (
        openItem?.questionId === questionId &&
        openItem?.locationId === locationId
      ) {
        if (targetName === "comments") {
          openItem.isComment = !openItem.isComment;
          openItem.isCloseItem = false;
        }
        if (targetName === "closeItem") {
          openItem.isCloseItem = !openItem.isCloseItem;
          openItem.isComment = false;
        }
        if (targetName === "commentText") {
          openItem.commentText = event;
        }
        if (targetName === "commentSubmit") {
          if (openItem.commentText === "") {
            openItem.commentTextError = true;
          } else {
            openItem.commentTextError = false;
            setAcceptable(parseInt(questionId));
            const data = {
              locationId: parseInt(locationId),
              comment: event,
              userId: parseInt(USER_ID()),
            };
            createSwInspectionItemCommentData(data);
          }
        }
        if (targetName === "dateClosedText") {
          openItem.dateClosedText = event;
        }
        if (targetName === "closedId") {
          const closevalue = getSwReference?.data?.ItemClosedActionList?.find(
            (item) => item.key === event,
          );
          openItem.closedId = closevalue?.key;
          openItem.closedIdValue = closevalue?.value;
        }
        if (targetName === "actionTakenText") {
          openItem.actionTakenText = event;
        }
        if (targetName === "closeItemSubmit") {
          if (!openItem.dateClosedText) {
            openItem.dateClosedError = true;
          } else {
            openItem.actionTakenError = false;
            openItem.dateClosedError = false;
            openItem.isClosedIdError = false;
            setAcceptable(parseInt(questionId));
            const data = {
              linkedReportId: reportDetail?.reportId ?? 0,
              listLocationId: [parseInt(locationId)],
              dateClosed: getFormatedDate(event),
              closedId: parseInt(openItem?.closedId),
              actionTaken: openItem.actionTakenText,
              userId: parseInt(USER_ID()),
            };
            createSwInspectionCloseItemData(data);
            setClosedLocationIds((prev) =>
              prev.includes(parseInt(locationId))
                ? prev
                : [...prev, parseInt(locationId)],
            );
          }
        }
        if (targetName === "cancelComment") {
          openItem.isComment = false;
        }
        if (targetName === "cancelCloseItem") {
          openItem.isCloseItem = false;
        }
      }
    });
    setPreviousItem(openItemClone);
  };

  const handleRadioType = (
    targetValue,
    questionValue,
    subCategoryValue,
    categoryValue,
    targetName,
    event,
  ) => {
    const listInspectionCategoryClone = [...listInspectionCategory];

    listInspectionCategoryClone.forEach((category) => {
      if (category?.key === categoryValue?.key) {
        category.listInspectionSubCategory.forEach((subCategory) => {
          if (subCategoryValue?.key === subCategory?.key) {
            subCategory.isAnswerCat = true;
            subCategory.listInspectionQuestionAnswer.forEach((question) => {
              updateQuestion(
                question,
                targetValue,
                targetName,
                questionValue,
                event,
                setAcceptable,
              );
            });
            updateSubCategoryPercent(subCategory);
          }
        });
        updateCategoryPercent(category);
      }
    });
    setListInspectionCategory(listInspectionCategoryClone);
  };

  const formchangeHnadle = (
    targetValue,
    questionValue,
    subCategoryValue,
    categoryValue,
    targetName,
    notAppce,
  ) => {
    const listInspectionCategoryClone = [...listInspectionCategory];
    listInspectionCategoryClone.forEach((category) => {
      if (category?.key === categoryValue?.key) {
        category.listInspectionSubCategory.forEach((subCategory) => {
          if (subCategoryValue?.key === subCategory?.key) {
            subCategory.listInspectionQuestionAnswer.forEach((question) => {
              if (question?.key == questionValue?.key) {
                // if (targetName === "significantDeviation") {
                //   question.significantDeviation = targetValue;
                // }
                // if (targetName === "proposedDimension") {
                //   question.proposedDimension = targetValue;
                // }
                // if (targetName === "actualDimension") {
                //   question.actualDimension = targetValue;
                // }
                question.notAcceptableList.forEach((notAcc) => {
                  if (notAcc.id === notAppce.id) {
                    if (targetName === "textFiled") {
                      notAcc.addLocationText = targetValue;
                    }
                    if (targetName === "fileChange") {
                      notAcc.addLocatioImg = targetValue.photo;
                      notAcc.addLocatioImgId = targetValue.fileDataId;
                    }
                    if (targetName === "itemFound") {
                      const asasas = question.options.find(
                        (item) => item.key === targetValue,
                      );
                      notAcc.itemFoundKey = asasas.key;
                      notAcc.itemFoundValue = asasas.value;
                      notAcc.itemDetails = "";
                      notAcc.itemFoundError = false;
                    }
                    if (targetName === "textArea") {
                      notAcc.itemDetails = targetValue;
                    }
                    if (targetName === "pushData" && notAcc.addLocationText) {
                      notAcc.addLocatioList?.push({
                        textVaue: notAcc.addLocationText,
                        imgUrl: notAcc.addLocatioImg,
                        fileId: notAcc.addLocatioImgId,
                        id: Date.now() + Math.floor(Math.random() * 100),
                      });
                      notAcc.addLocationText = "";
                      notAcc.addLocatioImg = "";
                      notAcc.addLocatioImgId = "";
                      notAcc.addLocationDetailError = false;
                    }
                  }
                });
              }
            });
          }
        });
      }
    });
    setListInspectionCategory(listInspectionCategoryClone);
  };

  // const formchangeThreeHnadle = (
  //   targetValue,
  //   questionValue,
  //   subCategoryValue,
  //   categoryValue,
  //   targetName
  // ) => {
  //   const listInspectionCategoryClone = [...listInspectionCategory];
  //   listInspectionCategoryClone.forEach((category) => {
  //     if (category?.key === categoryValue?.key) {
  //       category.listInspectionSubCategory.forEach((subCategory) => {
  //         if (subCategoryValue?.key === subCategory?.key) {
  //           subCategory.listInspectionQuestionAnswer.forEach((question) => {
  //             if (question?.key == questionValue?.key) {
  //               if (targetName === "significantDeviation") {
  //                 question.significantDeviationValue = targetValue;
  //               }
  //               if (targetName === "proposedDimension") {
  //                 question.proposedDimensionValue = targetValue;
  //               }
  //               if (targetName === "actualDimension") {
  //                 question.actualDimensionValue = targetValue;
  //               }
  //             }
  //           });
  //         }
  //       });
  //     }
  //   });
  //   setListInspectionCategory(listInspectionCategoryClone);
  // };
  const deleteform = (
    targetValue,
    questionValue,
    subCategoryValue,
    categoryValue,
  ) => {
    const listInspectionCategoryClone = [...listInspectionCategory];
    listInspectionCategoryClone.forEach((category) => {
      if (category?.key === categoryValue?.key) {
        category.listInspectionSubCategory.forEach((subCategory) => {
          if (subCategoryValue?.key === subCategory?.key) {
            subCategory.listInspectionQuestionAnswer.forEach((question) => {
              if (question?.key == questionValue?.key) {
                question.notAcceptableList = question.notAcceptableList?.filter(
                  (notAcc) => {
                    return notAcc.id !== targetValue;
                  },
                );
              }
            });
          }
        });
      }
    });
    setListInspectionCategory(listInspectionCategoryClone);
  };

  const deleteHandler = (
    categorys,
    subcategorys,
    questions,
    notAppce,
    noteee,
    deleteEvent,
  ) => {
    const listInspectionCategoryClone = [...listInspectionCategory];
    listInspectionCategoryClone.forEach((category) => {
      if (category?.key === categorys?.key) {
        category.listInspectionSubCategory.forEach((subCategory) => {
          if (subcategorys?.key === subCategory?.key) {
            subCategory.listInspectionQuestionAnswer.forEach((question) => {
              if (question?.key == questions?.key) {
                question.notAcceptableList.forEach((notAcc) => {
                  if (notAcc.id === notAppce.id) {
                    if (deleteEvent === "deleteText") {
                      notAcc.addLocatioList = notAcc.addLocatioList?.filter(
                        (item) => item.id !== noteee.id,
                      );
                    }
                    notAcc.addLocatioList.forEach((addOcationLi) => {
                      if (addOcationLi.id === noteee.id) {
                        if (deleteEvent === "deleteImg") {
                          delete addOcationLi.imgUrl;
                          delete addOcationLi.fileId;
                          delete addOcationLi.uniqeFileErrorMessage;
                        }
                      }
                    });
                  }
                });
              }
            });
          }
        });
      }
    });
    setListInspectionCategory(listInspectionCategoryClone);
  };

  const [clearCreateSwInspection, setClearCreateSwInspection] = useState(false);
  const [successScreens, setSuccessScreens] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);

  const onSubmit = (data) => {
    setSuccessScreens(true);
    setClearCreateSwInspection(true);
    if (data?.inspectionId === 0) {
      if (!acknowledgement) {
        data.certifyStatementId = 0;
      }
      dispatch(swInspectionAction.createSwInspection(data));
    } else {
      dispatch(swInspectionAction.updateSwInspection(data));
    }
  };

  const [isWeatherAtTimeofInspection, setIsWeatherAtTimeofInspection] =
    useState(false);
  const [isSoilTypeId, setIsSoilTypeId] = useState(false);
  const [isStageOfConstruction, setIsStageOfConstruction] = useState(false);
  const [isSampleTaken, setIsSampleTaken] = useState(false);
  const [isProjectStatus, setIsProjectStatus] = useState(false);
  const [isRainFallError, setIsRainFallError] = useState(false);
  const [isRainfallChecked, setIsRainfallChecked] = useState(false);
  const [isSiteAssessment, setIsSiteAssessment] = useState(false);
  const [isTnpeNumber, setIsTnpeNumber] = useState(false);
  const [isCpescNumber, setIsCpescNumber] = useState(false);

  const [
    isCurrentApproximateDisturbedAcreage,
    setIsCurrentApproximateDisturbedAcreage,
  ] = useState(false);
  const [isProjectName, setIsProjectName] = useState(false);
  const [isProjectNo, setIsProjectNo] = useState(false);
  const [isCustomerName, setIsCustomerName] = useState(false);
  const [isReportId, setIsReportId] = useState(false);
  const [isPrimaryInspector, setIsPrimaryInspector] = useState(false);
  const [isDateofInspection, setIsDateofInspection] = useState(false);
  const [isInspectionTypeId, setIsInspectionTypeId] = useState(false);
  const [isTimeofInspection, setIsTimeofInspection] = useState(false);

  const [signatureError, setSignatureError] = useState(false);
  const [twoQuestionError, setTwoQuestionError] = useState(false);
  const [projectPhaseError, setProjectPhaseError] = useState(false);
  const [siteComplianceError, setSiteComplianceError] = useState(false);

  function mappedData() {
    let errors = false;

    if (
      parseInt(signoffMethodValue) === SIGNOFF_METHOD_TYPE.CERTIFY_STATEMENT ||
      parseInt(signoffMethodValue) === 4
    ) {
      if (!checkedAcknowledgement && acknowledgement) {
        setCheckedAcknowledgementError(true);
        errors = true;
      } else {
        setCheckedAcknowledgementError(false);
        errors = false;
      }
    }

    if (
      parseInt(signoffMethodValue) === SIGNOFF_METHOD_TYPE.SIGNATURE ||
      parseInt(signoffMethodValue) === 4
    ) {
      if (!isSignatureProfile && !selectedContractorSignature) {
        setSignatureError(true);
        errors = true; // ← previously missing — this prevents submit
      } else {
        setSignatureError(false);
      }
    }

    if (
      Array.isArray(listInspectionCategory) &&
      listInspectionCategory.length === 0
    ) {
      toast("Something went wrong. Please try again.");
      setTimeout(() => {
        addDirectInspection ? window.location.reload() : navigate(SWDASHBOARD);
      }, 3000);
      errors = true;
    }

    if (frequencyValue === 7 && !frequencyInDays) {
      setDateRangeError(true);
      errors = true;
    } else {
      setDateRangeError(false);
    }

    if (
      (inspectionTypeId === 1 || inspectionTypeId === 3) &&
      (!frequencyValue || frequencyValue === 0 || frequencyValue === "")
    ) {
      setFrequencyValueError(true);
      errors = true;
    } else {
      setFrequencyValueError(false);
    }

    if (isNorthCarolina || isSouthCarolina) {
      if (
        !Array.isArray(swInspectionConfQuestionAns) ||
        swInspectionConfQuestionAns.length < 4
      ) {
        setTwoQuestionError(true);
        errors = true;
      } else {
        setTwoQuestionError(false);
      }
    }
    if (isTennessee) {
      if (!swInspectionSiteCompliance?.some((item) => item.siteAns)) {
        setSiteComplianceError(true);
        errors = true;
      } else {
        setSiteComplianceError(false);
      }
    }

    if (isNorthCarolina || isSouthCarolina) {
      if (!swInspectionCurrentProjectPhase?.some((item) => item.isChecked)) {
        setProjectPhaseError(true);
        errors = true;
      } else {
        setProjectPhaseError(false);
      }
    }
    const catErrorCheck = validateInspectionCategories(
      listInspectionCategory,
      setListInspectionCategory,
      previousItem,
      reportDetail?.reportId
    );

    const validateRequiredFields = () => {
      let validationErrors = false;
      const inspectionDate = formValue?.dateofInspection ?? date;
      if (
        inspectionDate &&
        !DATE_VALIDATE.test(getFormatedDate(inspectionDate))
      ) {
        setIsDateofInspection(true);
        validationErrors = true;
      } else {
        setIsDateofInspection(false);
      }

      if (isNorthCarolina || isSouthCarolina) {
        const invalidGroundStabilization =
          swInspectionGroundStabilization?.some((item) => {
            return (
              (item?.inspectionDate &&
                !DATE_VALIDATE.test(getFormatedDate(item?.inspectionDate))) ||
              (item?.dateCorrecion &&
                !DATE_VALIDATE.test(getFormatedDate(item?.dateCorrecion)))
            );
          });

        const invalidObservation = swInspectionObservation?.some((item) => {
          return (
            (item?.inspectionDate &&
              !DATE_VALIDATE.test(getFormatedDate(item?.inspectionDate))) ||
            (item?.dateCorrection &&
              !DATE_VALIDATE.test(getFormatedDate(item?.dateCorrection)))
          );
        });

        const invalidLotDisturbance = swInspectionLotDisturbance?.some(
          (item) => {
            return (
              (item?.disturbanceDate &&
                !DATE_VALIDATE.test(getFormatedDate(item?.disturbanceDate))) ||
              (item?.erosionControlDate &&
                !DATE_VALIDATE.test(getFormatedDate(item?.erosionControlDate)))
            );
          },
        );

        const invalidMeasures = swInspectionNewOrRevisedMeasures?.some(
          (item) => {
            return (
              item?.measureDate &&
              !DATE_VALIDATE.test(getFormatedDate(item?.measureDate))
            );
          },
        );

        if (
          invalidGroundStabilization ||
          invalidObservation ||
          invalidLotDisturbance ||
          invalidMeasures
        ) {
          toast.error("Please enter valid dates.");
          validationErrors = true;
        }
      }
      getInTyFeByInTyList?.data?.listInspectionTypeFields?.forEach((field) => {
        if (field?.isSelected && field?.isMandatory) {
          switch (field.key) {
            case 2:
              if (formValue?.projectNo === "") {
                setIsProjectNo(true);
                validationErrors = true;
              } else {
                setIsProjectNo(false);
              }
              break;
            case 3:
              if (formValue?.timeofInspection === "") {
                setIsTimeofInspection(true);
                validationErrors = true;
              } else {
                setIsTimeofInspection(false);
              }
              break;
            case 4:
              if (
                formValue?.WeatherAtTimeofInspection.value === "" ||
                formValue?.WeatherAtTimeofInspection.value === null ||
                formValue?.WeatherAtTimeofInspection.value === undefined
              ) {
                setIsWeatherAtTimeofInspection(true);
                validationErrors = true;
              } else {
                setIsWeatherAtTimeofInspection(false);
              }
              break;
            case 5:
              if (isRainfallEmpty(formValue?.rainfall)) {
                setIsRainFallError(true);
                validationErrors = true;
              } else {
                setIsRainFallError(false);
              }
              break;
            case 6:
              if (!formValue?.sampleTaken) {
                setIsSampleTaken(true);
                validationErrors = true;
              } else {
                setIsSampleTaken(false);
              }
              break;
            case 8:
              if (formValue?.reportId === null) {
                setIsReportId(true);
                validationErrors = true;
              } else {
                setIsReportId(false);
              }
              break;
            case 10:
              const inspectionDate = formValue?.dateofInspection ?? date;
              if (
                !inspectionDate ||
                (inspectionDate &&
                  !DATE_VALIDATE.test(getFormatedDate(inspectionDate)))
              ) {
                setIsDateofInspection(true);
                validationErrors = true;
              } else {
                setIsDateofInspection(false);
              }
              break;
            case 12:
              if (inspectionTypeId === null) {
                setIsInspectionTypeId(true);
                validationErrors = true;
              } else {
                setIsInspectionTypeId(false);
              }
              break;
            case 13:
              if (formValue?.primaryInspector === "") {
                setIsPrimaryInspector(true);
                validationErrors = true;
              } else {
                setIsPrimaryInspector(false);
              }
              break;
            case 14:
              if (
                formValue?.constructionStageId === "" ||
                formValue?.constructionStageId === null ||
                formValue?.constructionStageId === undefined ||
                parseInt(formValue?.constructionStageId) === 0
              ) {
                setIsStageOfConstruction(true);
                validationErrors = true;
              } else {
                setIsStageOfConstruction(false);
              }
              break;
            case 16:
              if (formValue?.disturbedAcreage === "") {
                setIsCurrentApproximateDisturbedAcreage(true);
                validationErrors = true;
              } else {
                setIsCurrentApproximateDisturbedAcreage(false);
              }
              break;
            case 17:
              if (
                formValue?.soilTypeId?.value === "" ||
                formValue?.soilTypeId.value === null ||
                formValue?.soilTypeId.value === undefined
              ) {
                setIsSoilTypeId(true);
                validationErrors = true;
              } else {
                setIsSoilTypeId(false);
              }
              break;
            case 18:
              if (
                constructionActivityId === "" ||
                constructionActivityId === null ||
                constructionActivityId === undefined ||
                parseInt(constructionActivityId) === 0
              ) {
                setIsConstructionActivityId(true);
                validationErrors = true;
              } else {
                setIsConstructionActivityId(false);
              }
              break;
            case 23:
              if (
                projectStatus === "" ||
                projectStatus === null ||
                projectStatus === undefined
              ) {
                setIsProjectStatus(true);
                validationErrors = true;
              } else {
                setIsProjectStatus(false);
              }
              break;
            case 29:
              if (!formValue?.isRainfallChecked) {
                setIsRainfallChecked(true);
                validationErrors = true;
              } else {
                setIsRainfallChecked(false);
              }
              break;
            case 30:
              if (!formValue?.siteAssessment) {
                setIsSiteAssessment(true);
                validationErrors = true;
              } else {
                setIsSiteAssessment(false);
              }
              break;
            case 31:
              if (!formValue?.cpescNumber) {
                setIsCpescNumber(true);
                validationErrors = true;
              } else {
                setIsCpescNumber(false);
              }
              break;
            case 32:
              if (!formValue?.tnpeNumber) {
                setIsTnpeNumber(true);
                validationErrors = true;
              } else {
                setIsTnpeNumber(false);
              }
              break;
            default:
              break;
          }
        }
      });

      return validationErrors;
    };
    const errorsCommonFeilds = validateRequiredFields();

    if (errors) {
      return false;
    }

    if (!errors && !errorsCommonFeilds && !catErrorCheck.isError) {
      return {
        inspectionId: inspectionId || 0,
        setupId: questionSetUpId || 0,
        status: INSSTATUS[0].key,
        inspectionDate: formValue.dateofInspection
          ? getFormatedDate(formValue.dateofInspection)
          : getFormatedDate(date),
        inspectionTime: formValue.timeofInspection || formattedTime,
        weatherTypeId: formValue.WeatherAtTimeofInspection?.key || 0,
        rainfall: formValue.rainfall || null,
        constructionStageId: formValue.constructionStageId || 0,
        isSampleTaken:
          formValue.sampleTaken === "3"
            ? true
            : formValue.sampleTaken === "1"
              ? false
              : null,
        projectStatus:
          projectStatus === "1" ? true : projectStatus === "2" ? false : null,
        constructionActivityId: constructionActivityId || 0,
        verticalId: 0,
        disturbedAcreage: formValue.disturbedAcreage || "",
        comment: formValue?.generalComments || "",
        preparedBy: parseInt(USER_ID()),
        signature: selectedContractorSignature || isSignatureProfile,
        soilTypeId: formValue?.soilTypeId?.key,
        permitteOrNPDESNumber: formValue?.permitteOrNPDESNumber,
        primaryPermitteName: formValue?.primaryPermitteName,
        projectId: formValue?.projectId ? parseInt(formValue?.projectId) : 0,
        questionSetId: questionSetId ? parseInt(questionSetId) : 0,
        inspectionType: inspectionTypeId ? parseInt(inspectionTypeId) : 0,
        frequencyId: frequencyValue ? frequencyValue : 0,
        alsoSubmitRoutineInspection:
          parseInt(inspectionTypeId) === 3 ? true : alsoSubmitRoutineInspection,
        isRainfallChecked:
          formValue.isRainfallChecked === "1"
            ? true
            : formValue.isRainfallChecked === "2"
              ? false
              : null,
        siteAssessment: parseInt(formValue?.siteAssessment),
        tnpeNumber: formValue?.tnpeNumber,
        cpescNumber: formValue?.cpescNumber,
        certifyStatementId: parseInt(certifyStatementIdValue),
        listInspectionCategory: listInspectionCategory,
        closedLocationIds: closedLocationIds,
        swInspectionConfQuestionAns:
          isNorthCarolina || isSouthCarolina ? swInspectionConfQuestionAns : [],
        swInspectionRainfallData:
          isNorthCarolina || isSouthCarolina
            ? processRainfallData(swInspectionRainfallData)
            : [],
        swInspectionCurrentProjectPhase:
          isNorthCarolina || isSouthCarolina
            ? processProjectPhaseData(swInspectionCurrentProjectPhase)
            : [],
        swInspectionGroundStabilization:
          isNorthCarolina || isSouthCarolina
            ? filterGroundStabilizationRows(swInspectionGroundStabilization)
            : [],
        swInspectionObservation:
          isNorthCarolina || isSouthCarolina
            ? filterObservationRows(swInspectionObservation)
            : [],
        swInspectionLotDisturbance:
          isNorthCarolina || isSouthCarolina
            ? filterLotDisturbanceRows(swInspectionLotDisturbance)
            : [],
        swInspectionNewOrRevisedMeasures: isNorthCarolina
          ? filterNewOrRevisedMeasuresRows(swInspectionNewOrRevisedMeasures)
          : [],
        orgId: clients?.key,
        frequencyInDays:
          frequencyInDays && frequencyValue === 7
            ? parseInt(frequencyInDays)
            : 0,
        swInspectionSiteCompliance: isTennessee
          ? processSiteComplianceData(swInspectionSiteCompliance)
          : [],
        signOffMethodType: parseInt(signoffMethodValue),
        epscInstalled:
          isTennessee && parseInt(epscInstalled) ? parseInt(epscInstalled) : 0,
        epscFunctioning:
          isTennessee && parseInt(epscFunctioning)
            ? parseInt(epscFunctioning)
            : 0,
      };
    }
  }

  const submitData = () => {
    if (InactiveClient()) return;
    const data = mappedData();
    if (!data) {
      return;
    }

    setRouteSatus(2);
    setIsSubmit(true);

    const result = data.listInspectionCategory.map((category) => {
      const item = {
        isSkipped: false,
        categoryId: category.key,
        sequenceNumber: category.sequenceNumber,
        listInspectionSubCategory: category.listInspectionSubCategory.map(
          (subCategory) => {
            return {
              isSkipped: false,
              subCategoryId: subCategory.key,
              sequenceNumber: subCategory.sequenceNumber,
              listInspectionQuestionAnswer:
                subCategory.listInspectionQuestionAnswer.map((question) => {
                  return {
                    sequenceId: question.quesNo,
                    answerMstId:
                      question.responseType === 2
                        ? 4
                        : question.radioSelectiovalue
                          ? parseInt(question.radioSelectiovalue)
                          : 0,
                    questionId: parseInt(question.key),
                    // actualDimension: question.actualDimensionValue,
                    // proposedDimension: question.proposedDimensionValue,
                    // significantDeviation:
                    //   question.significantDeviationValue || 0,
                    listInspectionQuestionAnswerDet:
                      question?.responseType === 2
                        ? [
                            {
                              details: question.textValueQuestion,
                              itemFoundId: question.itemFoundKey
                                ? question.itemFoundKey
                                : 0,
                              listInspectionDetailsLocation: [],
                            },
                          ]
                        : Array.isArray(question.notAcceptableList)
                          ? question.notAcceptableList.map((detail) => {
                              return {
                                details:
                                  question?.responseType === 2
                                    ? question.textValueQuestion
                                    : detail.itemDetails,
                                itemFoundId:
                                  detail.itemFoundKey ||
                                  question.itemFoundKey ||
                                  0,
                                listInspectionDetailsLocation:
                                  detail.addLocatioList
                                    ?.map((location) => {
                                      if (
                                        location.textVaue !== undefined &&
                                        parseInt(
                                          question.radioSelectiovalue,
                                        ) === 2
                                      ) {
                                        return {
                                          location: location.textVaue,
                                          files: [
                                            {
                                              subrootId: 0,
                                              fileId: location.addLocatioImgId
                                                ? parseInt(
                                                    location.addLocatioImgId,
                                                  )
                                                : location.fileId
                                                  ? parseInt(location.fileId)
                                                  : 0,
                                            },
                                          ],
                                        };
                                      }
                                      return null;
                                    })
                                    .filter((item) => item !== null),
                              };
                            })
                          : [],
                  };
                }),
            };
          },
        ),
      };
      return item;
    });

    data.listInspectionCategory = result;
    onSubmit(data);
  };
  const saveData = async () => {
    let errors = false;

    if (
      parseInt(signoffMethodValue) === SIGNOFF_METHOD_TYPE.CERTIFY_STATEMENT ||
      parseInt(signoffMethodValue) === 4
    ) {
      if (!checkedAcknowledgement && acknowledgement) {
        setCheckedAcknowledgementError(true);
        errors = true;
      } else {
        setCheckedAcknowledgementError(false);
        errors = false;
      }
    }

    const handleError = (message, action) => {
      errors = true;
      toast(message);
      setTimeout(action, 3000);
    };

    if (
      Array.isArray(listInspectionCategory) &&
      listInspectionCategory?.length === 0
    ) {
      const action = addDirectInspection
        ? window?.location?.reload
        : () => navigate(SWDASHBOARD);
      handleError("Something went wrong, please try again", action);
    }
    const inspectionDate = formValue?.dateofInspection ?? date;
    if (
      inspectionDate &&
      !DATE_VALIDATE.test(getFormatedDate(inspectionDate))
    ) {
      setIsDateofInspection(true);
      errors = true;
    } else {
      setIsDateofInspection(false);
    }

    // ADD THIS BLOCK HERE
    if (isNorthCarolina || isSouthCarolina) {
      const invalidGroundStabilization = swInspectionGroundStabilization?.some(
        (item) => {
          return (
            (item?.inspectionDate &&
              !DATE_VALIDATE.test(getFormatedDate(item?.inspectionDate))) ||
            (item?.dateCorrecion &&
              !DATE_VALIDATE.test(getFormatedDate(item?.dateCorrecion)))
          );
        },
      );

      const invalidObservation = swInspectionObservation?.some((item) => {
        return (
          (item?.inspectionDate &&
            !DATE_VALIDATE.test(getFormatedDate(item?.inspectionDate))) ||
          (item?.dateCorrection &&
            !DATE_VALIDATE.test(getFormatedDate(item?.dateCorrection)))
        );
      });

      const invalidLotDisturbance = swInspectionLotDisturbance?.some((item) => {
        return (
          (item?.disturbanceDate &&
            !DATE_VALIDATE.test(getFormatedDate(item?.disturbanceDate))) ||
          (item?.erosionControlDate &&
            !DATE_VALIDATE.test(getFormatedDate(item?.erosionControlDate)))
        );
      });

      const invalidMeasures = swInspectionNewOrRevisedMeasures?.some((item) => {
        return (
          item?.measureDate &&
          !DATE_VALIDATE.test(getFormatedDate(item?.measureDate))
        );
      });

      if (
        invalidGroundStabilization ||
        invalidObservation ||
        invalidLotDisturbance ||
        invalidMeasures
      ) {
        toast.error("Please enter valid dates.");
        errors = true;
      }
    }

    if (errors) return false;

    const {
      dateofInspection,
      timeofInspection,
      WeatherAtTimeofInspection,
      rainfall,
      constructionStageId,
      sampleTaken,
      projectStatus,
      soilTypeId,
      disturbedAcreage,
      permitteOrNPDESNumber,
      primaryPermitteName,
      generalComments,
      projectId,
      isRainfallChecked,
      siteAssessment,
      tnpeNumber,
      cpescNumber,
    } = formValue;

    const data = {
      inspectionId: inspectionId || 0,
      setupId: questionSetUpId || 0,
      status: INSSTATUS[1].key,
      inspectionDate: getFormatedDate(dateofInspection || date),
      inspectionTime: timeofInspection || formattedTime,
      weatherTypeId: WeatherAtTimeofInspection?.key || null,
      rainfall: rainfall || 0,
      constructionStageId: constructionStageId || null,
      isSampleTaken:
        sampleTaken === "3" ? true : sampleTaken === "1" ? false : null,
      projectStatus:
        projectStatus === "1" ? true : projectStatus === "2" ? false : null,
      constructionActivityId: constructionActivityId || null,
      verticalId: null,
      signature: selectedContractorSignature || isSignatureProfile,
      soilTypeId: soilTypeId?.key || 0,
      disturbedAcreage: disturbedAcreage || "",
      permitteOrNPDESNumber,
      primaryPermitteName,
      comment: generalComments || "",
      preparedBy: parseInt(USER_ID()),
      projectId: projectId ? parseInt(projectId) : 0,
      questionSetId: questionSetId ? parseInt(questionSetId) : 0,
      inspectionType: inspectionTypeId ? parseInt(inspectionTypeId) : 0,
      frequencyId: frequencyValue ? frequencyValue : 0,
      alsoSubmitRoutineInspection:
        parseInt(inspectionTypeId) === 3 ? true : alsoSubmitRoutineInspection,
      isRainfallChecked:
        isRainfallChecked === "1"
          ? true
          : isRainfallChecked === "2"
            ? false
            : null,
      siteAssessment: parseInt(siteAssessment),
      tnpeNumber: tnpeNumber,
      cpescNumber: cpescNumber,
      listInspectionCategory,
      orgId: clients?.key,
      frequencyInDays:
        frequencyInDays && frequencyValue === 7 ? parseInt(frequencyInDays) : 0,
      certifyStatementId: parseInt(certifyStatementIdValue),
      signOffMethodType: parseInt(signoffMethodValue),
      swInspectionConfQuestionAns:
        isNorthCarolina || isSouthCarolina ? swInspectionConfQuestionAns : [],
      swInspectionRainfallData:
        isNorthCarolina || isSouthCarolina
          ? processRainfallData(swInspectionRainfallData)
          : [],
      swInspectionCurrentProjectPhase:
        isNorthCarolina || isSouthCarolina
          ? processProjectPhaseData(swInspectionCurrentProjectPhase)
          : [],
      swInspectionGroundStabilization:
        isNorthCarolina || isSouthCarolina
          ? filterGroundStabilizationRows(swInspectionGroundStabilization)
          : [],
      swInspectionObservation:
        isNorthCarolina || isSouthCarolina
          ? filterObservationRows(swInspectionObservation)
          : [],
      swInspectionLotDisturbance:
        isNorthCarolina || isSouthCarolina
          ? filterLotDisturbanceRows(swInspectionLotDisturbance)
          : [],
      swInspectionNewOrRevisedMeasures: isNorthCarolina
        ? filterNewOrRevisedMeasuresRows(swInspectionNewOrRevisedMeasures)
        : [],
      swInspectionSiteCompliance: isTennessee
        ? processSiteComplianceData(swInspectionSiteCompliance)
        : [],

      epscInstalled:
        isTennessee && parseInt(epscInstalled) ? parseInt(epscInstalled) : 0,
      epscFunctioning:
        isTennessee && parseInt(epscFunctioning)
          ? parseInt(epscFunctioning)
          : 0,
    };
    data.listInspectionCategory = processCategories(
      data.listInspectionCategory,
    );

    onSubmit(data);
  };

  useEffect(() => {
    dispatch(swInspectionAction.clearSwInspection());
  }, []);

  const successScreen = (id, successMsg, label1, label4, label2) => {
    return (
      <SuccessScreen
        id={id}
        isUpdate={successMsg}
        route={routeSatus === 1 ? SWDASHBOARD : SWDASHBOARD}
        label1={label1}
        label4={label4}
        label2={label2}
      ></SuccessScreen>
    );
  };

  useEffect(() => {
    if (reportDetail && clients && editMode) {
      setQuestionSetId(reportDetail?.questionSetId);
      setQuestionSetUpId(reportDetail?.setupId);
      setInspectionTypeId(reportDetail?.inspectionTypeId);
      setStateValue(reportDetail?.stateId);
      setListPermitte(reportDetail?.listPermitte);
      setInspectionId(reportDetail?.reportId);
      const data = {
        InspectionId: reportDetail?.reportId,
        orgId: clients?.key,
      };
      getSwInspectionDetailData(data);

      const dataProject = {
        projectId: reportDetail?.projectId,
        orgId: clients?.key,
      };
      getProjectDetails(dataProject);
    }
  }, [reportDetail, editMode, clients]);
  useEffect(() => {
    if (inspectionHeaderDetails?.status === API_STATUS?.SUCCESS) {
      setListPermitte(inspectionHeaderDetails?.data?.listPermitte);
    }

    if (inspectionHeaderDetails?.data && !editMode) {
      setFormValue((prev) => ({
        ...prev,
        rainfall: formatRainfall(inspectionHeaderDetails?.data?.rainfall),
      }));

      setProjectStatus(
        inspectionHeaderDetails?.data?.projectStatus ? "1" : "2",
      );
    }
  }, [inspectionHeaderDetails, editMode, addMode]);
  useEffect(() => {
    if (
      inspectionHeaderDetails?.status === API_STATUS?.SUCCESS &&
      inspectionHeaderDetails?.data
    ) {
      setIsMediaAllowed(inspectionHeaderDetails?.data?.isMediaAllowed);
      setIsFluid(inspectionHeaderDetails?.data?.isFluid);
    }
    if (
      inspectionHeaderDetails?.status === API_STATUS?.SUCCESS &&
      inspectionHeaderDetails?.data &&
      !editMode
    ) {
      setFrequencyInDays(inspectionHeaderDetails?.data?.frequencyInDays);
    }
  }, [inspectionHeaderDetails, editMode]);

  useEffect(() => {
    if (
      ((inspectionHeaderDetails?.status === API_STATUS?.SUCCESS &&
        inspectionHeaderDetails?.data) ||
        (getSwInspectionDetail?.status === API_STATUS.SUCCESS &&
          getSwInspectionDetail?.isLoading === false)) &&
      !addDirectInspection &&
      parseInt(inspectionTypeId) === 1 &&
      !editMode
    ) {
      setFrequencyValue(
        getSwInspectionDetail?.data?.frequencyId
          ? getSwInspectionDetail?.data?.frequencyId
          : inspectionHeaderDetails?.data?.frequencyId,
      );
    }
    if (
      getSwInspectionDetail?.status === API_STATUS.SUCCESS &&
      getSwInspectionDetail?.isLoading === false &&
      editMode
    ) {
      setFrequencyValue(getSwInspectionDetail?.data?.frequencyId);
    }
  }, [inspectionHeaderDetails, getSwInspectionDetail, editMode]);

  useEffect(() => {
    if (addMode && reportDetail) {
      setFrequencyValue(reportDetail?.frequencyId);
      setFrequencyInDays(reportDetail?.frequencyInDays);
      setQuestionSetId(reportDetail?.questionSetId);
      setQuestionSetUpId(reportDetail?.setupId);
      setInspectionTypeId(reportDetail?.inspectionTypeId);
      setStateValue(reportDetail?.stateId);
      setListPermitte(reportDetail?.listPermitte);
      setInspectionId(reportDetail?.reportId);
      setFormValue((prev) => ({
        ...prev,
        questionSetName: reportDetail?.questionSetName,
        customerName: reportDetail?.customer,
        projectName: reportDetail?.projectName,
        projectId: reportDetail?.projectId,
        projectNo: reportDetail?.projectNumber
          ? reportDetail?.projectNumber
          : "N/A",
        primaryInspector: `${userInfo?.firstName} ${userInfo?.lastName}`,
        email: userInfo?.email,
        companyPerformingInspection: userInfo?.organization,
        phoneNumber: userInfo?.phoneNumber,
        jobTitle: userInfo?.jobTitle ?? "N/A",
        certificationNumber: userInfo?.certificationNumber ?? "N/A",
        reportId: reportDetail?.reportId,
        rainfall: formatRainfall(reportDetail?.rainfall),
        clientAddress1: userInfo?.clientAddress1,
        clientAddress2: userInfo?.clientAddress2,
        clientCity: userInfo?.clientCity,
        clientState: userInfo?.clientState,
        clientZipCode: userInfo?.clientZipCode,
      }));
    }
  }, [reportDetail, addMode, inspectionHeaderDetails]);

  useEffect(() => {
    if (reportDetail && clients && addMode) {
      const data = {
        questionSetId: reportDetail?.questionSetId,
        projectId: reportDetail?.projectId,
        orgId: clients?.key,
      };
      getSwInspectionDetailData(data);
    }
  }, [reportDetail, addMode, clients]);
  useEffect(() => {
    if (reportDetail && editMode && getInTyFeByInTyList) {
      setFormValue((prev) => ({
        ...prev,
        questionSetName: reportDetail?.questionSetName,
        permitteOrNPDESNumber: reportDetail?.permitteOrNPDESNumber,
        primaryPermitteName: reportDetail?.primaryPermitteName,
        reportId: reportDetail?.reportId,
      }));
    }
  }, [reportDetail, editMode, getInTyFeByInTyList]);

  useEffect(() => {
    if (
      getSwInspectionDetail?.status === API_STATUS.SUCCESS &&
      getSwInspectionDetail?.isLoading === false &&
      addMode &&
      getInTyFeByInTyList?.status === API_STATUS.SUCCESS &&
      getInTyFeByInTyList?.isLoading === false
    ) {
      if (getSwInspectionDetail?.data?.setupId && addMode) {
        setQuestionSetUpId(getSwInspectionDetail?.data?.setupId);
        setFormValue((prev) => ({
          ...prev,
          // rainfall: getSwInspectionDetail?.data?.rainfall,
          WeatherAtTimeofInspection: {
            key: getSwInspectionDetail?.data?.weatherTypeId,
            value: getSwInspectionDetail?.data?.weather,
          },
          soilTypeId: {
            key: getSwInspectionDetail?.data?.soilTypeId,
            value: getSwInspectionDetail?.data?.soilType,
          },
          constructionStageId: getSwInspectionDetail?.data?.constructionStageId,
          sampleTaken:
            getSwInspectionDetail?.data?.isSampleTaken === null
              ? null
              : getSwInspectionDetail?.data?.isSampleTaken
                ? "3"
                : "1",
          projectStatus: getSwInspectionDetail?.data?.projectStatus ? "1" : "2",
          primaryPermitteeName:
            getSwInspectionDetail?.data?.primaryPermitteName,
          disturbedAcreage: getSwInspectionDetail?.data?.disturbedAcreage,
          permitteOrNPDESNumber:
            getSwInspectionDetail?.data?.permitteOrNPDESNumber,
          generalComments: getSwInspectionDetail?.data?.comment,
          isRainfallChecked:
            getSwInspectionDetail?.data?.isRainfallChecked === null
              ? null
              : getSwInspectionDetail?.data?.isRainfallChecked
                ? "1"
                : "2",
          siteAssessment: parseInt(getSwInspectionDetail?.data?.siteAssessment),
          tnpeNumber: getSwInspectionDetail?.data?.tnpeNumber,
          cpescNumber: getSwInspectionDetail?.data?.cpescNumber,
          jobTitle: getSwInspectionDetail?.data?.jobTitle
            ? getSwInspectionDetail?.data?.jobTitle
            : "N/A",
          certificationNumber:
            getSwInspectionDetail?.data?.certificationNumber ??
            getSwInspectionDetail?.data?.inspectorCertification ??
            "N/A",
        }));
        setConstructionActivityId(
          getSwInspectionDetail?.data?.constructionActivityId,
        );
        setProjectStatus(
          getSwInspectionDetail?.data?.projectStatus ? "1" : "2",
        );
        setIsDirectIns(getSwInspectionDetail?.data?.isDirectIns);
        setEpscFunctioning(
          parseInt(getSwInspectionDetail?.data?.epscFunctioning),
        );
        setEpscInstalled(parseInt(getSwInspectionDetail?.data?.epscInstalled));
        const categoryData = getSwInspectionDetail?.data?.categoriesView;
        categoryData.forEach((category) => {
          category.categoryId = category.key;
          category.catAns = category?.subcategoriesView?.some(
            (itemss) => itemss.isAnswerGiven,
          );
          const perQuestionCat = 100 / category?.subcategoriesView?.length;
          const completedCat = category.subcategoriesView?.filter(
            (items) => items.isAnswerGiven,
          );
          category.catPercent = perQuestionCat * completedCat?.length;
          category.howManyCat = completedCat?.length;

          category.listInspectionSubCategory = category.subcategoriesView.map(
            (subcategory) => {
              subcategory.subCategoryId = subcategory.key;
              // MATCHES listInspectionCategoryObject: THE BULK BUTTONS ONLY APPLY
              // TO A SUB-CATEGORY MADE ENTIRELY OF RADIO QUESTIONS.
              subcategory.showBth = subcategory?.insQuesAnsReportView?.every(
                (findItem) =>
                  findItem?.responseType === 1 || findItem?.responseType === 3,
              );
              subcategory.subCatAns = subcategory?.insQuesAnsReportView?.some(
                (itemss) => itemss.answerMstId,
              );
              subcategory.listInspectionQuestionAnswer =
                subcategory.insQuesAnsReportView.map((questions) => {
                  questions.questionSequenceNumber = questions.sequenceId;
                  questions.key = questions.questionId;
                  questions.value = questions.question;
                  questions.radioSelectiovalue = questions.answerMstId;
                  questions.textValueQuestion =
                    questions.detailsReportView[0]?.details;
                  // questions.actualDimensionValue = questions.actualDimension;
                  // questions.proposedDimensionValue =
                  //   questions.proposedDimension;
                  // questions.significantDeviationValue =
                  //   questions.significantDeviation ?? 0;
                  questions.notAcceptableList =
                    questions.responseType === 1 || questions.responseType === 3
                      ? questions.detailsReportView?.length > 0
                        ? addMode
                          ? []
                          : questions.detailsReportView.map((notAcc) => {
                              notAcc.id =
                                Date.now() + Math.floor(Math.random() * 100);
                              notAcc.itemFoundKey = notAcc.itemFoundId;
                              notAcc.itemFoundValue = notAcc.itemFound;
                              notAcc.itemDetails = notAcc.details;
                              notAcc.addLocatioList =
                                notAcc.locationsReportView?.map((locationV) => {
                                  locationV.textVaue = locationV.location;
                                  locationV.id = locationV.locationId;
                                  locationV.imgUrl =
                                    locationV.files[0]?.filePath;
                                  locationV.addLocatioImgId =
                                    locationV.files[0]?.fileId;
                                  return locationV;
                                });
                              return notAcc;
                            })
                        : (questions.detailsReportView = [])
                      : [];
                  return questions;
                });
              const perQuestionSub =
                100 / subcategory?.insQuesAnsReportView?.length;
              const completedSub = subcategory.insQuesAnsReportView.filter(
                (items) => items.answerMstId,
              );
              subcategory.subPercent = perQuestionSub * completedSub?.length;
              subcategory.howManySub = completedSub?.length;
              return subcategory;
            },
          );
        });
        const groundStabilizationFormattedData =
          getSwInspectionDetail?.data?.swInspectionGroundStabilization?.map(
            (item) => ({
              ...item,
              isStabilizationInstalled:
                item?.isStabilizationInstalled === true
                  ? 1
                  : item?.isStabilizationInstalled === false
                    ? 2
                    : null,
              dateVerified: parseDate(item.dateVerified, "MM-dd-yyyy"),
              inspectionDate: parseDate(item.inspectionDate, "MM-dd-yyyy"),
              dateCorrecion: parseDate(item.dateCorrecion, "MM-dd-yyyy"),
            }),
          );

        const lotDisturbanceFormattedData =
          getSwInspectionDetail?.data?.swInspectionLotDisturbance?.map(
            (item) => ({
              ...item,
              disturbanceDate: parseDate(item.disturbanceDate, "MM-dd-yyyy"),
              erosionControlDate: parseDate(
                item.erosionControlDate,
                "MM-dd-yyyy",
              ),
              stabilizationDate: parseDate(
                item.stabilizationDate,
                "MM-dd-yyyy",
              ),
            }),
          );
        const inspectionNewOrRevisedMeasuresFormatData =
          getSwInspectionDetail?.data?.swInspectionNewOrRevisedMeasure?.map(
            (item) => ({
              ...item,
              measureDate: parseDate(item.measureDate, "MM-dd-yyyy"),
            }),
          );

        setSwInspectionConfQuestionAns(
          getSwInspectionDetail?.data?.swInspectionConfQuestionAns,
        );
        setSwInspectionGroundStabilization(groundStabilizationFormattedData);
        setSwInspectionObservation(
          getSwInspectionDetail?.data?.swInspectionObservation,
        );
        setSwInspectionLotDisturbance(lotDisturbanceFormattedData);
        setSwInspectionNewOrRevisedMeasures(
          inspectionNewOrRevisedMeasuresFormatData,
        );
        setListInspectionCategory(categoryData);

        setCertifyStatementIdValue(
          getSwInspectionDetail?.data?.questionSetCertifyStatementId,
        );
        setAcknowledgement(
          getSwInspectionDetail?.data?.questionSetCertifyStatement,
        );

        setSignoffMethodValue(
          getSwInspectionDetail?.data?.questionSetSignOffMethodType,
        );
      } else {
        setFormValue((prev) => ({
          ...prev,
          rainfall: formatRainfall(reportDetail?.rainfall),
          WeatherAtTimeofInspection: "",
          soilTypeId: "",
          constructionStageId: "",
          sampleTaken: "",
          projectStatus: "",
          primaryPermitteeName: "",
          disturbedAcreage: "",
          permitteOrNPDESNumber: "",
          generalComments: "",
        }));
        setConstructionActivityId();
      }
      if (getSwInspectionDetail?.data?.setupId) {
        const getQuestionIds = getSwInspectionDetail?.data?.categoriesView
          ?.map((x) =>
            x?.subcategoriesView?.flatMap((y) =>
              y?.insQuesAnsReportView?.map((z) => z.questionId),
            ),
          )
          .flat()
          .filter((id) => id !== undefined);

        const data = {
          questionList: getQuestionIds,
          setupId: null,
          projectId: getSwInspectionDetail?.data?.projectId,
          questionSetId: getSwInspectionDetail?.data?.questionSetId,
          itemStatus: 2,
          orgId: clients?.key,
        };
        getOpenItemDetailData(data);
      }
    }
  }, [
    getSwInspectionDetail,
    addMode,
    getInTyFeByInTyList,
    reportDetail,
    clients,
  ]);
  useEffect(() => {
    if (
      getSwInspectionDetail?.status === API_STATUS.SUCCESS &&
      getSwInspectionDetail?.isLoading === false &&
      !reportDetail &&
      !editMode &&
      addDirectInspection &&
      questionSetId &&
      getInTyFeByInTyList?.status === API_STATUS.SUCCESS &&
      getInTyFeByInTyList?.isLoading === false
    ) {
      const inspectionData = getSwInspectionDetail?.data;

      if (inspectionData?.setupId) {
        setFormValue((prev) => ({
          ...prev,
          isStandalone: inspectionData?.isStandAloneProject,
          questionSetName: inspectionData?.questionSetName,
          projectName: inspectionData?.projectName,
          projectId: inspectionData?.projectId,
          customerName: inspectionData?.inspectorCompanyName,
          projectNo: inspectionData?.projectNumber
            ? inspectionData?.projectNumber
            : "N/A",
          primaryInspector: `${userInfo?.firstName} ${userInfo?.lastName}`,
          email: userInfo?.email,
          companyPerformingInspection: userInfo?.organization,
          phoneNumber: userInfo?.phoneNumber,
          // dateofInspection: inspectionData?.dateOfInspection,
          // timeofInspection: inspectionData?.timeOfInspection,
          rainfall: formatRainfall(inspectionHeaderDetails?.data?.rainfall),
          WeatherAtTimeofInspection: {
            key: inspectionData?.weatherTypeId,
            value: inspectionData?.weather,
          },
          soilTypeId: {
            key: inspectionData.soilTypeId,
            value: inspectionData.soilType,
          },
          constructionStageId: inspectionData?.constructionStageId,
          sampleTaken: transformSampleTaken(inspectionData?.isSampleTaken),
          projectStatus: transformProjectStatus(inspectionData?.projectStatus),
          primaryPermitteeName: inspectionData?.primaryPermitteName,
          disturbedAcreage: inspectionData?.disturbedAcreage,
          permitteOrNPDESNumber: inspectionData?.permitteOrNPDESNumber,
          generalComments: inspectionData?.comment,
          isRainfallChecked:
            inspectionData?.isRainfallChecked === null
              ? null
              : inspectionData?.isRainfallChecked
                ? "1"
                : "2",
          siteAssessment: parseInt(inspectionData?.siteAssessment),
          tnpeNumber: inspectionData?.tnpeNumber,
          cpescNumber: inspectionData?.cpescNumber,
          jobTitle: userInfo?.jobTitle ?? "N/A",
          certificationNumber: userInfo?.certificationNumber ?? "N/A",
          clientAddress1: userInfo?.clientAddress1,
          clientAddress2: userInfo?.clientAddress2,
          clientCity: userInfo?.clientCity,
          clientState: userInfo?.clientState,
          clientZipCode: userInfo?.clientZipCode,
        }));
        setConstructionActivityId(inspectionData?.constructionActivityId);
        setProjectStatus(transformProjectStatus(inspectionData?.projectStatus));
        setIsDirectIns(inspectionData?.isDirectIns);
        setQuestionSetUpId(inspectionData?.setupId);

        const categoryData = transformCategoryData(
          inspectionData?.categoriesView,
        );

        setListInspectionCategory(categoryData);
        setCertifyStatementIdValue(
          getSwInspectionDetail?.data?.questionSetCertifyStatementId,
        );
        setAcknowledgement(
          getSwInspectionDetail?.data?.questionSetCertifyStatement,
        );

        setSignoffMethodValue(
          getSwInspectionDetail?.data?.questionSetSignOffMethodType,
        );

        setEpscFunctioning(
          parseInt(getSwInspectionDetail?.data?.epscFunctioning),
        );
        setEpscInstalled(parseInt(getSwInspectionDetail?.data?.epscInstalled));

        const groundStabilizationFormattedData =
          getSwInspectionDetail?.data?.swInspectionGroundStabilization?.map(
            (item) => ({
              ...item,
              isStabilizationInstalled:
                item?.isStabilizationInstalled === true
                  ? 1
                  : item?.isStabilizationInstalled === false
                    ? 2
                    : null,
              dateVerified: parseDate(item.dateVerified, "MM-dd-yyyy"),
              inspectionDate: parseDate(item.inspectionDate, "MM-dd-yyyy"),
              dateCorrecion: parseDate(item.dateCorrecion, "MM-dd-yyyy"),
            }),
          );

        const lotDisturbanceFormattedData =
          getSwInspectionDetail?.data?.swInspectionLotDisturbance?.map(
            (item) => ({
              ...item,
              disturbanceDate: parseDate(item.disturbanceDate, "MM-dd-yyyy"),
              erosionControlDate: parseDate(
                item.erosionControlDate,
                "MM-dd-yyyy",
              ),
              stabilizationDate: parseDate(
                item.stabilizationDate,
                "MM-dd-yyyy",
              ),
            }),
          );

        const inspectionNewOrRevisedMeasuresFormatData =
          getSwInspectionDetail?.data?.swInspectionNewOrRevisedMeasure?.map(
            (item) => ({
              ...item,
              measureDate: parseDate(item.measureDate, "MM-dd-yyyy"),
            }),
          );

        setSwInspectionConfQuestionAns(
          getSwInspectionDetail?.data?.swInspectionConfQuestionAns,
        );

        if (
          inspectionData?.swInspectionCurrentProjectPhase &&
          inspectionData?.swInspectionCurrentProjectPhase?.length > 0
        ) {
          const updatedInsQuestionOptionList =
            getSwReference?.data?.InsQuestionOptionList?.map((option) => {
              const matchingInspectionData =
                getSwInspectionDetail?.data?.swInspectionCurrentProjectPhase?.find(
                  (inspection) => inspection.optionId === option.key,
                );
              return {
                ...option,
                optionId: option.key,
                isChecked: matchingInspectionData
                  ? matchingInspectionData?.isChecked
                  : false,
                comment: matchingInspectionData
                  ? matchingInspectionData?.comment
                  : "",
                status: matchingInspectionData
                  ? matchingInspectionData?.status
                  : 0,
              };
            });
          setSwInspectionCurrentProjectPhase(updatedInsQuestionOptionList);
        } else {
          const updatedOptions = getSwReference.data.InsQuestionOptionList?.map(
            (option) => ({
              ...option,
              optionId: option.key,
              isChecked: false,
              comment: "",
              status: 0,
            }),
          );
          setSwInspectionCurrentProjectPhase(updatedOptions);
        }

        if (
          inspectionData?.swInspectionSiteComplianceAnsView &&
          inspectionData?.swInspectionSiteComplianceAnsView?.length > 0
        ) {
          const updatedSwInspectionSiteCompliance =
            getSwReference?.data?.SwInspectionSiteCompliance?.map((option) => {
              const matchingInspectionData =
                getSwInspectionDetail?.data?.swInspectionSiteComplianceAnsView?.find(
                  (inspection) => inspection.itemId === option.key,
                );
              return {
                ...option,
                itemId: option.key,
                siteAns: matchingInspectionData
                  ? matchingInspectionData?.siteAns
                  : false,
                siteComment: matchingInspectionData
                  ? matchingInspectionData?.siteComment
                  : "",
              };
            });
          setSwInspectionSiteCompliance(updatedSwInspectionSiteCompliance);
        } else {
          const updatedOptions =
            getSwReference.data.SwInspectionSiteCompliance?.map((option) => ({
              ...option,
              itemId: option.key,
              siteAns: false,
              siteComment: "",
            }));
          setSwInspectionSiteCompliance(updatedOptions);
        }
        setSwInspectionGroundStabilization(groundStabilizationFormattedData);
        setSwInspectionObservation(inspectionData?.swInspectionObservation);
        setSwInspectionLotDisturbance(lotDisturbanceFormattedData);
        setSwInspectionNewOrRevisedMeasures(
          inspectionNewOrRevisedMeasuresFormatData,
        );
        const getQuestionIds = getQuestionIdsFromCategories(
          inspectionData?.categoriesView,
        );
        if (getQuestionIds?.length > 0) {
          const data = {
            questionList: getQuestionIds,
            setupId: null,
            projectId: inspectionData?.projectId,
            questionSetId: inspectionData?.questionSetId,
            itemStatus: 2,
            orgId: clients?.key,
          };
          getOpenItemDetailData(data);
        }
      } else {
        setFormValue((prev) => ({
          ...prev,
          WeatherAtTimeofInspection: "",
          soilTypeId: "",
          constructionStageId: "",
          sampleTaken: "",
          projectStatus: "",
          primaryPermitteeName: "",
          disturbedAcreage: "",
          permitteOrNPDESNumber: "",
          generalComments: "",
          isRainfallChecked: null,
        }));
        setConstructionActivityId(null);
        setProjectStatus(null);
        setQuestionSetUpId(0);
        setInspectionId(0);
      }
    }
  }, [
    getSwInspectionDetail,
    reportDetail,
    editMode,
    addDirectInspection,
    questionSetId,
    getInTyFeByInTyList,
    clients,
  ]);

  useEffect(() => {
    if (
      getSwInspectionDetail?.status === API_STATUS.SUCCESS &&
      getSwInspectionDetail?.isLoading === false &&
      editMode &&
      reportDetail &&
      getInTyFeByInTyList?.status === API_STATUS.SUCCESS &&
      getInTyFeByInTyList?.isLoading === false
    ) {
      setFormValue((prev) => ({
        ...prev,
        questionSetName: reportDetail?.questionSet,
        projectName: getSwInspectionDetail?.data?.projectName,
        projectId: getSwInspectionDetail?.data?.projectId,
        customerName: getSwInspectionDetail?.data?.clientName,
        projectNo: getSwInspectionDetail?.data?.projectNumber
          ? getSwInspectionDetail?.data?.projectNumber
          : "N/A",
        primaryInspector: editMode
          ? getSwInspectionDetail?.data?.inspectorName
          : `${userInfo?.firstName} ${userInfo?.lastName}`,
        email: editMode
          ? getSwInspectionDetail?.data?.inspectorEmail
          : userInfo?.email,
        companyPerformingInspection: userInfo?.organization,
        phoneNumber: editMode
          ? getSwInspectionDetail?.data?.inspectorContactNumber
          : userInfo?.phoneNumber,
        jobTitle: editMode
          ? getSwInspectionDetail?.data?.jobtitle
          : userInfo?.jobTitle
            ? userInfo?.jobTitle
            : "N/A",
        certificationNumber: editMode
          ? (getSwInspectionDetail?.data?.certificationNumber ??
            getSwInspectionDetail?.data?.inspectorCertification ??
            "N/A")
          : userInfo?.certificationNumber
            ? userInfo?.certificationNumber
            : "N/A",
        dateofInspection:
          getSwInspectionDetail?.data?.statusId === 5
            ? getSwInspectionDetail?.data?.dateOfInspection
            : date,
        timeofInspection:
          getSwInspectionDetail?.data?.statusId === 5
            ? getSwInspectionDetail?.data?.timeOfInspection
            : formattedTime,
        rainfall: formatRainfall(getSwInspectionDetail?.data?.rainfall),
        WeatherAtTimeofInspection: {
          key: getSwInspectionDetail?.data?.weatherTypeId,
          value: getSwInspectionDetail?.data?.weather,
        },
        soilTypeId: {
          key: getSwInspectionDetail?.data?.soilTypeId,
          value: getSwInspectionDetail?.data?.soilType,
        },
        constructionStageId: getSwInspectionDetail?.data?.constructionStageId,
        sampleTaken: transformSampleTaken(
          getSwInspectionDetail?.data?.isSampleTaken,
        ),
        projectStatus: transformProjectStatus(
          getSwInspectionDetail?.data?.projectStatus,
        ),
        primaryPermitteeName: getSwInspectionDetail?.data?.primaryPermitteName,
        disturbedAcreage: getSwInspectionDetail?.data?.disturbedAcreage,
        permitteOrNPDESNumber:
          getSwInspectionDetail?.data?.permitteOrNPDESNumber,
        generalComments: getSwInspectionDetail?.data?.comment,
        isStandalone: getSwInspectionDetail?.data?.isStandAloneProject,
        isRainfallChecked:
          getSwInspectionDetail?.data?.isRainfallChecked === null
            ? null
            : getSwInspectionDetail?.data?.isRainfallChecked
              ? "1"
              : "2",
        siteAssessment: parseInt(getSwInspectionDetail?.data?.siteAssessment),
        tnpeNumber: getSwInspectionDetail?.data?.tnpeNumber,
        cpescNumber: getSwInspectionDetail?.data?.cpescNumber,
        clientAddress1: userInfo?.clientAddress1,
        clientAddress2: userInfo?.clientAddress2,
        clientCity: userInfo?.clientCity,
        clientState: userInfo?.clientState,
        clientZipCode: userInfo?.clientZipCode,
      }));
      setConstructionActivityId(
        getSwInspectionDetail?.data?.constructionActivityId,
      );
      setAlsoSubmitRoutineInspection(
        getSwInspectionDetail?.data?.alsoSubmitRoutineInspection,
      );
      setIsDirectIns(getSwInspectionDetail?.data?.isDirectIns);
      setFrequencyInDays(getSwInspectionDetail?.data?.frequencyInDays);
      setProjectStatus(
        transformProjectStatus(getSwInspectionDetail?.data?.projectStatus),
      );
      setSelectedContractorSignature(getSwInspectionDetail?.data?.signature);

      const categoryData = getSwInspectionDetail?.data?.categoriesView;
      const prevEditMode = true;
      const transformedCategoryData = transformCategoryData(
        categoryData,
        prevEditMode,
      );

      setListInspectionCategory(transformedCategoryData);
      setCertifyStatementIdValue(
        getSwInspectionDetail?.data?.certifyStatementId,
      );
      setAcknowledgement(getSwInspectionDetail?.data?.certifyStatement);
      setEpscFunctioning(
        parseInt(getSwInspectionDetail?.data?.epscFunctioning),
      );
      setEpscInstalled(parseInt(getSwInspectionDetail?.data?.epscInstalled));
      setSignoffMethodValue(getSwInspectionDetail?.data?.signOffMethodType);
      const groundStabilizationFormattedData =
        getSwInspectionDetail?.data?.swInspectionGroundStabilization?.map(
          (item) => ({
            ...item,
            isStabilizationInstalled:
              item?.isStabilizationInstalled === true
                ? 1
                : item?.isStabilizationInstalled === false
                  ? 2
                  : null,
            dateVerified: parseDate(item.dateVerified, "MM-dd-yyyy"),
            inspectionDate: parseDate(item.inspectionDate, "MM-dd-yyyy"),
            dateCorrecion: parseDate(item.dateCorrecion, "MM-dd-yyyy"),
          }),
        );

      const lotDisturbanceFormattedData =
        getSwInspectionDetail?.data?.swInspectionLotDisturbance?.map(
          (item) => ({
            ...item,
            disturbanceDate: parseDate(item.disturbanceDate, "MM-dd-yyyy"),
            erosionControlDate: parseDate(
              item.erosionControlDate,
              "MM-dd-yyyy",
            ),
            stabilizationDate: parseDate(item.stabilizationDate, "MM-dd-yyyy"),
          }),
        );
      const inspectionNewOrRevisedMeasuresFormatData =
        getSwInspectionDetail?.data?.swInspectionNewOrRevisedMeasure?.map(
          (item) => ({
            ...item,
            measureDate: parseDate(item.measureDate, "MM-dd-yyyy"),
          }),
        );
      setSwInspectionConfQuestionAns(
        getSwInspectionDetail?.data?.swInspectionConfQuestionAns,
      );
      setSwInspectionCurrentProjectPhase(
        getSwInspectionDetail?.data?.swInspectionCurrentProjectPhase,
      );
      setSwInspectionSiteCompliance(
        getSwInspectionDetail?.data?.swInspectionSiteComplianceAnsView,
      );
      setSwInspectionGroundStabilization(groundStabilizationFormattedData);
      setSwInspectionObservation(
        getSwInspectionDetail?.data?.swInspectionObservation,
      );
      setSwInspectionLotDisturbance(lotDisturbanceFormattedData);
      setSwInspectionNewOrRevisedMeasures(
        inspectionNewOrRevisedMeasuresFormatData,
      );
      if (getSwInspectionDetail?.data?.setupId) {
        const getQuestionIds = getQuestionIdsFromCategories(
          getSwInspectionDetail?.data?.categoriesView,
        );

        const data = {
          questionList: getQuestionIds,
          setupId: null,
          projectId: getSwInspectionDetail?.data?.projectId,
          questionSetId: getSwInspectionDetail?.data?.questionSetId,
          itemStatus: 2,
          orgId: clients?.key,
        };
        getOpenItemDetailData(data);
      }
    }
  }, [
    getSwInspectionDetail,
    editMode,
    reportDetail,
    getInTyFeByInTyList,
    clients,
  ]);

  const getOpenItem = (questionDetail) => {
    const findItems = Object?.keys(previousItem).reduce((result, key) => {
      const item = previousItem[key];
      if (
        item.questionId === questionDetail.key &&
        questionDetail.radioSelectiovalue === "2"
      ) {
        result[key] = item;
      }
      return result;
    }, {});
    return (
      <PreviousOpenItems
        openItemHandler={openItemHandler}
        previousItem={findItems ? findItems : []}
      />
    );
  };
  useEffect(() => {
    if (!editMode) {
      const preData = JSON.parse(JSON.stringify(previousItem));
      if (
        swOpenItemDetail.status === API_STATUS.SUCCESS &&
        getSwInspectionDetail.status === API_STATUS.SUCCESS &&
        !getSwInspectionDetail?.data?.setupId
      ) {
        const filterData = preData.filter(
          (prev) => prev.questionId !== notAcceptable,
        );
        setPreviousItem(
          openItemObject([...swOpenItemDetail.data.openItemList]),
        );
        const updatedList = listInspectionCategory?.map((category) => {
          const updatedSubCategories = category?.listInspectionSubCategory?.map(
            (subCategory) => {
              const updatedQuestions =
                subCategory?.listInspectionQuestionAnswer?.map((question) => {
                  const matchingOpenItem =
                    swOpenItemDetail?.data?.openItemList?.find(
                      (item) => item.questionId === question.key,
                    );
                  if (matchingOpenItem) {
                    question.radioSelectiovalue = "2";
                  } else {
                    question.radioSelectiovalue = "";
                  }
                  return question;
                });
              return {
                ...subCategory,
                listInspectionQuestionAnswer: updatedQuestions,
              };
            },
          );
          return {
            ...category,
            listInspectionSubCategory: updatedSubCategories,
          };
        });
      }
    }
  }, [swOpenItemDetail, editMode, getSwInspectionDetail]);

  useEffect(() => {
    if (getSwInspectionDetail.status === API_STATUS.SUCCESS) {
      if (
        (addMode || addDirectInspection) &&
        getSwQuestionSetDetail.status === API_STATUS.SUCCESS &&
        questionSetId &&
        !getSwInspectionDetail?.data?.setupId &&
        (reportDetail?.projectId || projects)
      ) {
        setCertifyStatementIdValue(
          getSwQuestionSetDetail?.data?.certifyStatementId,
        );
        setSignoffMethodValue(getSwQuestionSetDetail?.data?.signOffMethodType);
        const getQuestionIds =
          getSwQuestionSetDetail?.data?.questionSetCatDetails
            ?.map((x) =>
              x?.subcategories?.flatMap((y) =>
                y?.questions?.filter((z) => z.isSelected).map((xz) => xz.key),
              ),
            )
            .flat()
            .filter((id) => id !== undefined);

        const data = {
          questionList: getQuestionIds,
          setupId: null,
          projectId: reportDetail?.projectId
            ? reportDetail?.projectId
            : projects?.key,
          questionSetId: questionSetId,
          itemStatus: 2,
          orgId: clients?.key,
        };
        getOpenItemDetailData(data);
      }
    }
  }, [
    getSwInspectionDetail,
    getSwQuestionSetDetail,
    reportDetail,
    addMode,
    questionSetId,
    addDirectInspection,
    clients,
  ]);

  useEffect(() => {
    if (
      editMode &&
      getSwInspectionDetail.status === API_STATUS.SUCCESS &&
      questionSetUpId &&
      projects?.key
    ) {
      const getQuestionIds = getSwInspectionDetail?.data?.categoriesView
        ?.map((x) =>
          x?.subcategoriesView?.flatMap((y) =>
            y?.insQuesAnsReportView?.map((z) => z.questionId),
          ),
        )
        .flat()
        .filter((id) => id !== undefined);

      const data = {
        questionList: getQuestionIds,
        setupId: null,
        projectId: projects?.key,
        questionSetId: questionSetId,
        itemStatus: 2,
        orgId: clients?.key,
      };
      getOpenItemDetailData(data);
    }
  }, [
    getSwInspectionDetail,
    editMode,
    projects?.key,
    questionSetUpId,
    clients,
  ]);

  const addMediaNotAccUploadFile = (data) => {
    const validation = validateFileSize(data);
    if (!validation.isValid) {
      setFileError(validation.errorMessage);
      setUniqeFileError(1);
      return;
    }
    setIsNotAddMedia(true);
    setIsLoader(true);
    fileUpload(data)
      .then((res) => {
        setIsLoader(false);
        const files = { files: res };
        setFileUploadData(files);
        setUniqeFileError(2);
      })
      .catch((error) => {
        setFileError("Error while uploading files.");
        setUniqeFileError(1);
      });
  };

  const [notCategoryId, setNotCategoryId] = useState();
  const [notSubcategory, setNotSubcategory] = useState();
  const [notNotQuestionId, setNotQuestionId] = useState();
  const [notNotAppce, setNotNotAppce] = useState();
  const [actions, setActions] = useState(null);

  const addMediaNotAccUpload = (
    event,
    question,
    subcategory,
    category,
    notAppce,
    noteee,
  ) => {
    setNotCategoryId(category?.key);
    setNotSubcategory(subcategory?.key);
    setNotQuestionId(question?.key);
    setNotNotAppce(notAppce?.id);
    setActions(noteee?.id);

    const fileUploaded = event.target.files[0];
    handleaddMediaNotAccUploadMethod(fileUploaded);
  };

  const handleaddMediaNotAccUploadMethod = (data) => {
    addMediaNotAccUploadFile(data);
  };

  useEffect(() => {
    if (isNotAddMedia && fileUploadData) {
      const listInspectionCategoryClone = [...listInspectionCategory];
      if (fileUploadData && !imageCheck) {
        listInspectionCategoryClone.forEach((category) => {
          if (category?.key === notCategoryId) {
            category.listInspectionSubCategory.forEach((subCategory) => {
              if (subCategory?.key === notSubcategory) {
                subCategory.listInspectionQuestionAnswer.forEach((question) => {
                  if (question?.key == notNotQuestionId) {
                    question.notAcceptableList.forEach((notAcc) => {
                      if (notAcc.id === notNotAppce) {
                        notAcc.addLocatioList.forEach((actio) => {
                          if (actio.id === actions) {
                            actio.imgUrl = fileUploadData?.files[0]?.fileUrl;
                            actio.fileId = fileUploadData?.files[0]?.id;
                          }
                        });
                      }
                    });
                  }
                });
              }
            });
          }
        });
      }

      setListInspectionCategory(listInspectionCategoryClone);
    }
  }, [isNotAddMedia, fileUploadData]);

  useEffect(() => {
    if (uniqeFileError === 1) {
      const listInspectionCategoryClone = [...listInspectionCategory];
      listInspectionCategoryClone.forEach((category) => {
        if (category?.key === notCategoryId) {
          category.listInspectionSubCategory.forEach((subCategory) => {
            if (subCategory?.key === notSubcategory) {
              subCategory.listInspectionQuestionAnswer.forEach((question) => {
                if (question?.key == notNotQuestionId) {
                  question.notAcceptableList.forEach((notAcc) => {
                    if (notAcc.id === notNotAppce) {
                      notAcc.addLocatioList.forEach((actio) => {
                        if (actio.id === actions) {
                          actio.uniqeFileErrorMessage = true;
                        } else {
                          actio.uniqeFileErrorMessage = false;
                        }
                      });
                    }
                  });
                }
              });
            }
          });
        }
      });

      setListInspectionCategory(listInspectionCategoryClone);
    }
  }, [uniqeFileError]);

  useEffect(() => {
    if (getSwProjectDetailData) {
      setFormValue((prev) => ({
        ...prev,
        isStandalone: getSwProjectDetailData?.data?.result?.isStandalone,
      }));
    }
  }, [getSwProjectDetailData]);

  useEffect(() => {
    if (projects?.key || formValue?.projectId) {
      const data = {
        projectId: projects?.key || formValue?.projectId,
        orgId: clients?.key,
      };
      getProjectDetails(data);
    }
  }, [projects, clients, formValue?.projectId]);

  useEffect(() => {
    if (inspectionQuestionSetList?.data) {
      setIsGeorgiaState(inspectionQuestionSetList?.data?.isGeorgiaState);
    }
  }, [inspectionQuestionSetList]);

  useEffect(() => {
    if (statusApi && !addDirectInspection) {
      toast("something went wrong please try again");
      setTimeout(function () {
        navigate(SWDASHBOARD);
      }, 3000);
    }
    if (statusApi && addDirectInspection) {
      toast("something went wrong please try again");
      setTimeout(function () {
        window.location.reload();
      }, 3000);
    }
  }, [statusApi, addDirectInspection]);

  useEffect(() => {
    if (reportDetail) {
      setClients({
        key: reportDetail?.customerId,
        value: reportDetail?.customer,
      });
    }
  }, [reportDetail]);

  const [showSuccessScreen, setShowSuccessScreen] = useState(true);

  useEffect(() => {
    if (
      createSwInspection.status === "SUCCESS" &&
      createSwInspection?.data?.responseMessages?.responseCode === "HBNG002"
    ) {
      toast(createSwInspection?.data?.responseMessages?.responseMessage);
      setShowSuccessScreen(false);
    }
  }, [createSwInspection]);

  useEffect(() => {
    if (inspectionHeaderDetails?.data?.stateId === 23) {
      setIsNorthCarolina(true);
      setIsTennessee(false);
      setIsSouthCarolina(false);
    } else if (inspectionHeaderDetails?.data?.stateId === 3) {
      setIsTennessee(true);
      setIsNorthCarolina(false);
      setIsSouthCarolina(false);
    } else if (inspectionHeaderDetails?.data?.stateId === 42) {
      setIsSouthCarolina(true);
      setIsNorthCarolina(false);
      setIsTennessee(false);
    } else {
      setIsNorthCarolina(false);
      setIsTennessee(false);
      setIsSouthCarolina(false);
    }
  }, [inspectionHeaderDetails]);

  const fetchRainfallData = () => {
    const rawDate = formValue?.dateofInspection;
    const inspectionDate = new Date(rawDate);

    if (!rawDate || isNaN(inspectionDate.getTime())) {
      return;
    }

    const fromDate = new Date(inspectionDate);
    fromDate.setDate(inspectionDate.getDate() - 7);

    const formattedFromDate = fromDate.toISOString().split("T")[0];
    const formattedToDate = inspectionDate.toISOString().split("T")[0];

    const defaultData = {
      page: 1,
      pageSize: 7,
      rainfallType: 1,
      projectId: projects?.key || reportDetail?.projectId,
      fromDate: getFormatedDate(formattedFromDate),
      toDate: getFormatedDate(formattedToDate),
      search: "",
      OrgId: clients?.key ? parseInt(clients?.key) : parseInt(ORG_ID()),
    };

    swGetRainFallDataList(defaultData);
  };

  useEffect(() => {
    if (
      isNorthCarolina ||
      isSouthCarolina ||
      projects ||
      reportDetail?.projectId
    ) {
      fetchRainfallData();
    }
  }, [isNorthCarolina, isSouthCarolina, projects, formValue.dateofInspection]);

  useEffect(() => {
    if (
      (isNorthCarolina || isSouthCarolina) &&
      swRainFallData?.status === API_STATUS?.SUCCESS &&
      swRainFallData?.data?.historyPrecipList &&
      !editMode
    ) {
      if (swRainFallData?.data?.historyPrecipList) {
        const inspectionNotes =
          getSwInspectionDetail?.data?.swInspectionRainfallData?.map(
            (inspection) => inspection.notes,
          ) || [];

        const updatedHistoryPrecipList =
          swRainFallData?.data?.historyPrecipList?.map((option, index) => ({
            ...option,
            day: option?.precipDateFormat,
            rainfallAmt: option?.evenTrackPrecipAmt,
            notes: inspectionNotes[index] || "",
          }));

        setSwInspectionRainfallData(updatedHistoryPrecipList);
      } else {
        const updatedOptions = swRainFallData?.data?.historyPrecipList?.map(
          (option) => ({
            ...option,
            day: option?.precipDateFormat,
            rainfallAmt: option?.evenTrackPrecipAmt,
          }),
        );
        setSwInspectionRainfallData(updatedOptions);
      }
    } else if (
      (isNorthCarolina || isSouthCarolina) &&
      getSwInspectionDetail?.status === API_STATUS.SUCCESS &&
      getSwInspectionDetail?.data &&
      swRainFallData.status === API_STATUS.SUCCESS &&
      swRainFallData?.data?.historyPrecipList &&
      editMode
    ) {
      const inspectionNotes =
        getSwInspectionDetail?.data?.swInspectionRainfallData?.map(
          (inspection) => inspection.notes,
        ) || [];

      const updatedHistoryPrecipList =
        swRainFallData?.data?.historyPrecipList?.map((option, index) => ({
          ...option,
          day: option?.precipDateFormat,
          rainfallAmt: option?.evenTrackPrecipAmt,
          notes: inspectionNotes[index] || "",
        }));

      setSwInspectionRainfallData(updatedHistoryPrecipList);
    }
  }, [
    isNorthCarolina,
    isSouthCarolina,
    getSwInspectionDetail?.data,
    swRainFallData?.data?.historyPrecipList,
    editMode,
  ]);

  useEffect(() => {
    if (
      (isNorthCarolina || isSouthCarolina) &&
      getSwReference?.data?.InsQuestionOptionList &&
      !editMode
    ) {
      if (getSwInspectionDetail?.data?.swInspectionCurrentProjectPhase) {
        const updatedInsQuestionOptionList =
          getSwReference?.data?.InsQuestionOptionList?.map((option) => {
            const matchingInspectionData =
              getSwInspectionDetail?.data?.swInspectionCurrentProjectPhase?.find(
                (inspection) => inspection.optionId === option.key,
              );
            return {
              ...option,
              optionId: option.key,
              isChecked: matchingInspectionData
                ? matchingInspectionData?.isChecked
                : false,
              comment: matchingInspectionData
                ? matchingInspectionData?.comment
                : "",
              status: matchingInspectionData
                ? matchingInspectionData?.status
                : 0,
            };
          });
        setSwInspectionCurrentProjectPhase(updatedInsQuestionOptionList);
      } else {
        const updatedOptions = getSwReference.data.InsQuestionOptionList?.map(
          (option) => ({
            ...option,
            optionId: option.key,
            isChecked: false,
            comment: "",
            status: 0,
          }),
        );
        setSwInspectionCurrentProjectPhase(updatedOptions);
      }
    } else if (
      (isNorthCarolina || isSouthCarolina) &&
      getSwReference?.data?.InsQuestionOptionList &&
      getSwInspectionDetail?.data &&
      editMode
    ) {
      const updatedInsQuestionOptionList =
        getSwReference?.data?.InsQuestionOptionList?.map((option) => {
          const matchingInspectionData =
            getSwInspectionDetail?.data?.swInspectionCurrentProjectPhase?.find(
              (inspection) => inspection.optionId === option.key,
            );
          return {
            ...option,
            optionId: option.key,
            isChecked: matchingInspectionData
              ? matchingInspectionData?.isChecked
              : false,
            comment: matchingInspectionData
              ? matchingInspectionData?.comment
              : "",
            status: matchingInspectionData ? matchingInspectionData?.status : 0,
          };
        });
      setSwInspectionCurrentProjectPhase(updatedInsQuestionOptionList);
    }
  }, [
    isNorthCarolina,
    isSouthCarolina,
    getSwReference?.data,
    getSwInspectionDetail?.data,
    editMode,
  ]);

  useEffect(() => {
    if (
      isTennessee &&
      getSwReference?.data?.SwInspectionSiteCompliance &&
      !editMode
    ) {
      if (getSwInspectionDetail?.data?.swInspectionSiteComplianceAnsView) {
        const updatedInspectionSiteCompliance =
          getSwReference?.data?.SwInspectionSiteCompliance?.map((option) => {
            const matchingInspectionData =
              getSwInspectionDetail?.data?.swInspectionSiteComplianceAnsView?.find(
                (inspection) => inspection.itemId === option.key,
              );
            return {
              ...option,
              itemId: option.key,
              siteAns: matchingInspectionData
                ? matchingInspectionData?.siteAns
                : false,
              siteComment: matchingInspectionData
                ? matchingInspectionData?.siteComment
                : "",
            };
          });
        setSwInspectionSiteCompliance(updatedInspectionSiteCompliance);
      } else {
        const updatedOptions =
          getSwReference.data.SwInspectionSiteCompliance?.map((option) => ({
            ...option,
            itemId: option.key,
            siteAns: false,
            siteComment: "",
          }));
        setSwInspectionSiteCompliance(updatedOptions);
      }
    } else if (
      isTennessee &&
      getSwReference?.data?.SwInspectionSiteCompliance &&
      getSwInspectionDetail?.data &&
      editMode
    ) {
      const updatedInspectionSiteCompliance =
        getSwReference?.data?.SwInspectionSiteCompliance?.map((option) => {
          const matchingInspectionData =
            getSwInspectionDetail?.data?.swInspectionSiteComplianceAnsView?.find(
              (inspection) => inspection.itemId === option.key,
            );
          return {
            ...option,
            itemId: option.key,
            siteAns: matchingInspectionData
              ? matchingInspectionData?.siteAns
              : false,
            siteComment: matchingInspectionData
              ? matchingInspectionData?.siteComment
              : "",
          };
        });

      setSwInspectionSiteCompliance(updatedInspectionSiteCompliance);
    }
  }, [
    isTennessee,
    getSwReference?.data,
    getSwInspectionDetail?.data,
    editMode,
  ]);

  const disabledCheck = () => {
    if (editMode && checkPrivileges([12])) {
      return false;
    } else if (addMode && (inspectionTypeId === 3 || inspectionTypeId === 2)) {
      return false;
    } else if (editMode || !addDirectInspection) {
      return true;
    } else {
      return false;
    }
  };

  useEffect(() => {
    const res = createSwInspection?.data?.[0];

    if (res?.responseCode === "HBNG015") {
      toast(res?.responseMessage || "This Client is Inactive");
    }
  }, [createSwInspection]);

  useEffect(() => {
    const res = updateSwInspection?.data?.[0];

    if (res?.responseCode === "HBNG015") {
      toast(res?.responseMessage || "This Client is Inactive");
    }
  }, [updateSwInspection]);

  useEffect(() => {
    if (
      getSwInspectionDetail.status === API_STATUS.SUCCESS &&
      getSwInspectionDetail?.data?.setupId === 0 &&
      getSwProjectDetailData
    ) {
      const next = {
        primaryInspector: `${userInfo?.firstName ?? ""} ${
          userInfo?.lastName ?? ""
        }`.trim(),
        email: userInfo?.email,
        companyPerformingInspection: userInfo?.organization,
        phoneNumber: userInfo?.phoneNumber,
        jobTitle: userInfo?.jobTitle ?? "N/A",
        certificationNumber: userInfo?.certificationNumber ?? "N/A",
        projectNo: getSwProjectDetailData?.data?.result?.projectNumber ?? "N/A",
        isStandalone: getSwProjectDetailData?.data?.result?.isStandalone,
        clientAddress1: userInfo?.clientAddress1,
        clientAddress2: userInfo?.clientAddress2,
        clientCity: userInfo?.clientCity,
        clientState: userInfo?.clientState,
        clientZipCode: userInfo?.clientZipCode,
      };
      setFormValue((prev) => ({
        ...prev,
        ...next,
      }));
    }
  }, [getSwProjectDetailData, getSwInspectionDetail, userInfo]);

  useEffect(() => {
    dispatch(
      assetsAction.getAssetDynomoList({
        orgId: clients?.key,
        searchText: debouncedSearch,
        type: 5,
      }),
    );
  }, [debouncedSearch]);

  useEffect(() => {
    dispatch(clientAction.searchAllClients(debouncedClientSearch));
  }, [debouncedClientSearch]);

  const twoQuesFunctioningHandler = (e) => {
    setEpscFunctioning(e?.target?.value);
  };
  const twoQuesInstalledHandler = (e) => {
    setEpscInstalled(e?.target?.value);
  };

  return (
    <>
      {checkPrivileges([12, 102, 103]) ? (
        <>
          {(showLoader || isLoader) && <Loader />}

          {createSwInspection.status === "SUCCESS" &&
          createSwInspection?.data?.[0]?.responseCode !== "HBNG015" &&
          createSwInspection.data &&
          createSwInspection &&
          createSwInspection?.data?.responseMessages?.responseCode !==
            "HBNG002" &&
          successScreens ? (
            successScreen(
              createSwInspection?.data?.inspectionId,
              "Inspection Added Successfully",
              "Inspection Id",
              "Inspection List in",
              " ",
            )
          ) : updateSwInspection.status === "SUCCESS" &&
            updateSwInspection?.data?.[0]?.responseCode !== "HBNG015" &&
            updateSwInspection.data &&
            clearCreateSwInspection &&
            createSwInspection?.data?.responseMessages?.responseCode !==
              "HBNG002" &&
            successScreens ? (
            successScreen(
              updateSwInspection?.data?.inspectionId,
              "Inspection Updated Successfully",
              " ",
              "Inspection List in",
              "has been Updated",
            )
          ) : (
            <>
              <AddReport
                userInfo={userInfo}
                questionSetId={questionSetId}
                swQuestionSetDetail={listInspectionCategory}
                getInTyFeByInTyList={
                  getInTyFeByInTyList?.data?.listInspectionTypeFields
                }
                handleRadioType={handleRadioType}
                formchangeHnadle={formchangeHnadle}
                formValue={formValue}
                setFormValue={setFormValue}
                submitData={submitData}
                isSubmit={isSubmit}
                deleteform={deleteform}
                saveData={saveData}
                selectedContractorSignature={selectedContractorSignature}
                contractorsignatureUpload={contractorsignatureUpload}
                inspectionDetail={getSwInspectionDetail?.data ?? []}
                editMode={editMode}
                reportId={reportDetail?.reportId}
                deleteHandler={deleteHandler}
                isWeatherAtTimeofInspection={isWeatherAtTimeofInspection}
                isSoilTypeId={isSoilTypeId}
                isStageOfConstruction={isStageOfConstruction}
                isSampleTaken={isSampleTaken}
                isCurrentApproximateDisturbedAcreage={
                  isCurrentApproximateDisturbedAcreage
                }
                previousItem={previousItem}
                getOpenItem={getOpenItem}
                openItemHandler={openItemHandler}
                getSwReference={getSwReference?.data ?? []}
                signatureError={signatureError}
                isSignatureProfile={isSignatureProfile}
                hiddenAttendeeSignatureInput={hiddenAttendeeSignatureInput}
                addMediaNotAccUpload={addMediaNotAccUpload}
                setImageCheck={setImageCheck}
                listPermitte={listPermitte}
                isProjectName={isProjectName}
                isCustomerName={isCustomerName}
                isProjectNo={isProjectNo}
                isPrimaryInspector={isPrimaryInspector}
                isDateofInspection={isDateofInspection}
                isTimeofInspection={isTimeofInspection}
                mapId={mapId}
                handleAllProjectSearch={handleAllProjectSearch}
                isProjectLoading={isProjectLoading}
                allProjects={allProject?.data}
                projects={projects}
                onChangeProjects={onChangeProjects}
                inspectionQuestionSetList={
                  isQuestionSetLoading
                    ? []
                    : inspectionQuestionSetList?.data?.result
                }
                inspectionTypeId={inspectionTypeId}
                handleInspectionTypeSetChange={handleInspectionTypeSetChange}
                handleQuestionSetChange={handleQuestionSetChange}
                allClients={allClients?.data}
                clients={clients}
                searchClient={searchClient}
                onChangeClients={onChangeClients}
                isSearchClientLoading={isSearchClientLoading}
                firstClientError={firstClientError}
                inspectionHeaderDetails={inspectionHeaderDetails?.data}
                constructionActivityId={constructionActivityId}
                handleConstructionActivitySetChange={
                  handleConstructionActivitySetChange
                }
                isConstructionActivityId={isConstructionActivityId}
                frequencyValue={frequencyValue}
                handleFrequencyChange={handleFrequencyChange}
                isMediaAllowed={isMediaAllowed}
                isGeorgiaState={isGeorgiaState}
                projectStatus={projectStatus}
                setProjectStatus={setProjectStatus}
                alsoSubmitRoutineInspection={alsoSubmitRoutineInspection}
                handleChangeDefault={handleChangeDefault}
                isRainFallError={isRainFallError}
                isDirectIns={isDirectIns}
                isFluid={isFluid}
                frequencyInDays={frequencyInDays}
                dateRangeHandler={dateRangeHandler}
                dateRangeError={dateRangeError}
                errorFrequencyInDays={errorFrequencyInDays}
                fileError={fileError}
                signaureFileError={signaureFileError}
                signaureFileErrorMessage={signaureFileErrorMessage}
                isNorthCarolina={isNorthCarolina}
                swInspectionConfQuestionAns={swInspectionConfQuestionAns}
                setSwInspectionConfQuestionAns={setSwInspectionConfQuestionAns}
                swRainFallData={swInspectionRainfallData}
                swInspectionRainfallData={swInspectionRainfallData}
                setSwInspectionRainfallData={setSwInspectionRainfallData}
                swInspectionCurrentProjectPhase={
                  swInspectionCurrentProjectPhase
                }
                setSwInspectionCurrentProjectPhase={
                  setSwInspectionCurrentProjectPhase
                }
                swInspectionGroundStabilization={
                  swInspectionGroundStabilization
                }
                setSwInspectionGroundStabilization={
                  setSwInspectionGroundStabilization
                }
                swInspectionObservation={swInspectionObservation}
                setSwInspectionObservation={setSwInspectionObservation}
                swInspectionLotDisturbance={swInspectionLotDisturbance}
                setSwInspectionLotDisturbance={setSwInspectionLotDisturbance}
                setSwInspectionNewOrRevisedMeasures={
                  setSwInspectionNewOrRevisedMeasures
                }
                swInspectionNewOrRevisedMeasures={
                  swInspectionNewOrRevisedMeasures
                }
                // formchangeThreeHnadle={formchangeThreeHnadle}
                frequencyValueError={frequencyValueError}
                disabledCheck={disabledCheck}
                weather={weather}
                swRainFallDataModalData={swRainFallData?.data}
                fetchRainfallData={fetchRainfallData}
                twoQuestionError={twoQuestionError}
                projectPhaseError={projectPhaseError}
                siteComplianceError={siteComplianceError}
                isReportId={isReportId}
                isProjectStatus={isProjectStatus}
                isRainfallChecked={isRainfallChecked}
                isSiteAssessment={isSiteAssessment}
                isTnpeNumber={isTnpeNumber}
                isCpescNumber={isCpescNumber}
                swInspectionSiteCompliance={swInspectionSiteCompliance}
                setSwInspectionSiteCompliance={setSwInspectionSiteCompliance}
                isTennessee={isTennessee}
                signoffMethodValue={signoffMethodValue}
                certifyStatementIdValue={certifyStatementIdValue}
                acknowledgement={acknowledgement}
                setAcknowledgement={setAcknowledgement}
                isSouthCarolina={isSouthCarolina}
                setCheckedAcknowledgement={setCheckedAcknowledgement}
                checkedAcknowledgement={checkedAcknowledgement}
                checkedAcknowledgementError={checkedAcknowledgementError}
                getSwProjectDetailData={getSwProjectDetailData}
                twoQuesInstalledHandler={twoQuesInstalledHandler}
                twoQuesFunctioningHandler={twoQuesFunctioningHandler}
                epscFunctioning={epscFunctioning}
                epscInstalled={epscInstalled}
              />
              <ToastContainer />
            </>
          )}
        </>
      ) : (
        navigate(ACCESS_DENIED)
      )}
    </>
  );
};

export default AddReportContainer;
